/* DO NOT EDIT MANUALLY - this file is generated by GraphQL Code Generator */
/* eslint-disable */
import type { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
import type { MaterialIcon } from 'vscode-material-icons';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Git commit ID (full hash) */
  CommitSHA: { input: string; output: string };
  /** Date string in ISO 8601 format */
  Date: { input: string; output: string };
  /** Email address string defined by WHATWG HTML Standard with some RFC-related enhancements */
  Email: { input: string; output: string };
  /** Text with Markdown formatting */
  Markdown: { input: string; output: string };
  /** Icon name from VSCode's Material Icon Theme extension */
  MaterialIcon: { input: MaterialIcon; output: MaterialIcon };
  /** NPM package name */
  NpmPackageName: { input: string; output: string };
  /** NPM package version */
  NpmPackageVersion: { input: string; output: string };
  /** Human-readable and URL-safe ID string */
  Slug: { input: string; output: string };
  /** Web URL string defined by WHATWG URL Standard */
  URL: { input: string; output: string };
};

/** Action for checking permissions */
export enum Action {
  /** Creating a new subject */
  Create = 'Create',
  /** Deleting a subject */
  Delete = 'Delete',
  /** Fetching a subject */
  Read = 'Read',
  /** Modifying a subject */
  Update = 'Update',
}

/** Generated API key */
export type ApiKey = {
  /** Metadata */
  metadata: ApiKeyMetadata;
  /** Authentication token (cannot be retrieved later) */
  token: Scalars['String']['output'];
};

/** API key metadata */
export type ApiKeyMetadata = {
  /** Creation date */
  createdAt: Scalars['Date']['output'];
  /** Creator */
  createdBy?: Maybe<User>;
  /** Expiry */
  expiresAt?: Maybe<Scalars['Date']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Is expired? */
  isExpired: Scalars['Boolean']['output'];
  /** Last usage */
  lastUsedAt?: Maybe<Scalars['Date']['output']>;
  /** Friendly name */
  name: Scalars['String']['output'];
  /** Project API key has access to (null if whole organization) */
  project?: Maybe<Project>;
  /** Permissions scope */
  scope: Scope;
};

/** Audit with report */
export type Audit = Node & {
  /** Categories which reference this audit */
  categories: Array<Category>;
  /** Usage in categories/groups as percentage */
  contributions: AuditContributions;
  /** Description in Markdown */
  description?: Maybe<Scalars['Markdown']['output']>;
  /** Additional details (e.g. issues, tables) */
  details?: Maybe<AuditDetails>;
  /** Web link to audit's documentation */
  docsUrl?: Maybe<Scalars['URL']['output']>;
  /** Display value (e.g. '1.2 s' or '345 kB') */
  formattedValue?: Maybe<Scalars['String']['output']>;
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
  /** Issues' stats */
  issuesStats?: Maybe<IssuesStats>;
  /** Plugin where this audit originates */
  plugin: Plugin;
  /** Computed score */
  score: Scalars['Float']['output'];
  /** Audit slug */
  slug: Scalars['Slug']['output'];
  /** Display name */
  title: Scalars['String']['output'];
  /** Raw numeric value (in base unit, e.g. milliseconds or bytes) */
  value: Scalars['Float']['output'];
};

/** Audit's percentage in category */
export type AuditCategoryContribution = {
  /** Category */
  category: Category;
  /** Percentage calculated from weights */
  percentage: Scalars['Float']['output'];
};

/** Audit from report comparison */
export type AuditComparison = Node & {
  /** Audit from new report (missing if removed) */
  after?: Maybe<Audit>;
  /** Audit from old report (missing if added) */
  before?: Maybe<Audit>;
  /** Audit details' comparison */
  details?: Maybe<AuditDetailsComparison>;
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
  /** Status of audit - improved/regressed/etc. */
  status: AuditComparisonStatus;
  /** Changes to audit score and value */
  trend?: Maybe<AuditTrend>;
};

/** Paginated audit comparisons (shape follows Relay spec) */
export type AuditComparisonConnection = {
  /** Pagination items */
  edges: Array<AuditComparisonEdge>;
  /** Pagination info */
  pageInfo: PageInfo;
};

/** Reference to audit comparison in page (shape follows Relay spec) */
export type AuditComparisonEdge = {
  /** Pagination cursor */
  cursor: Scalars['String']['output'];
  /** AuditComparison */
  node: AuditComparison;
};

/** Filters for audits from reports comparison */
export type AuditComparisonFilters = {
  /** Only audits refenced by any of these categories will be fetched */
  categories?: InputMaybe<Array<Scalars['Slug']['input']>>;
  /** Only audits matching any of these statuses will be fetched */
  statuses?: InputMaybe<Array<AuditComparisonStatus>>;
};

/** Possibles states of audit when comparing reports */
export enum AuditComparisonStatus {
  /** Audit is present in new report, but not old report */
  Added = 'Added',
  /** Audit's score is unchanged, but value changed */
  Changed = 'Changed',
  /** Audit's score went up */
  Improved = 'Improved',
  /** Audit's score went down */
  Regressed = 'Regressed',
  /** Audit is present in old report, but not new report */
  Removed = 'Removed',
  /** Audit's score and value are unchanged */
  Unchanged = 'Unchanged',
}

/** Paginated audit reports (shape follows Relay spec) */
export type AuditConnection = {
  /** Pagination items */
  edges: Array<AuditEdge>;
  /** Pagination info */
  pageInfo: PageInfo;
};

/** Audit's usage in categories/groups as percentage */
export type AuditContributions = {
  /** Categories which reference audit */
  categories: Array<AuditCategoryContribution>;
  /** Groups with reference audit */
  groups: Array<AuditGroupContribution>;
};

/** Details of audit report */
export type AuditDetails = {
  /** Does this audit use any details? */
  enabled: Scalars['Boolean']['output'];
  /** Number of uncovered issues per severity level */
  issueCounts?: Maybe<Array<IssueSeverityCount>>;
  /** Additional data in table format */
  tables: Array<Table>;
  /** How many tables are in audit details */
  tablesCount: Scalars['Int']['output'];
  /** Additional data in tree format */
  trees: Array<Tree>;
  /** How many trees are in audit details */
  treesCount: Scalars['Int']['output'];
};

/** Audit details compared between reports */
export type AuditDetailsComparison = {
  /** Are audit details used in both reports? */
  enabled: Scalars['Boolean']['output'];
  /** Issues changes between reports */
  issuesComparison?: Maybe<IssuesComparison>;
  /** Issue counts diffs (new minus old) */
  issuesStats?: Maybe<IssuesStats>;
  /** Table changes between reports */
  tablesComparison?: Maybe<TablesComparison>;
  /** Table counts diff (new minus old) */
  tablesCount: Scalars['Int']['output'];
  /** Tree changes between reports */
  treesComparison?: Maybe<TreesComparison>;
  /** Tree counts diff (new minus old) */
  treesCount: Scalars['Int']['output'];
};

/** Reference to audit report in page (shape follows Relay spec) */
export type AuditEdge = {
  /** Pagination cursor */
  cursor: Scalars['String']['output'];
  /** Audit report */
  node: Audit;
};

/** Filters for audits */
export type AuditFilters = {
  /** Audits must match these categories */
  categories?: InputMaybe<Array<Scalars['Slug']['input']>>;
  /** Audits must originate in these plugins */
  plugins?: InputMaybe<Array<Scalars['Slug']['input']>>;
  /** Audits must contain this title substring */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Audit's percentage in group */
export type AuditGroupContribution = {
  /** Group */
  group: Group;
  /** Percentage calculated from weights */
  percentage: Scalars['Float']['output'];
};

/** Audit or group */
export type AuditOrGroup = Audit | Group;

/** Audit comparison or group comparison */
export type AuditOrGroupComparison = AuditComparison | GroupComparison;

/** Sort order */
export enum AuditOrder {
  /** Sort by plugin slug in ascending order (i.e. alphabetical) */
  PluginAsc = 'Plugin_ASC',
  /** Sort by plugin slug in descending order (i.e. reversed alphabetical) */
  PluginDesc = 'Plugin_DESC',
  /** Sort by audit score in ascending order (i.e. from lowest number) */
  ScoreAsc = 'Score_ASC',
  /** Sort by audit score in descending order (i.e. from highest number) */
  ScoreDesc = 'Score_DESC',
  /** Sort by audit title in ascending order (i.e. alphabetical) */
  TitleAsc = 'Title_ASC',
  /** Sort by audit title in descending order (i.e. reversed alphabetical) */
  TitleDesc = 'Title_DESC',
  /** Sort by audit value in ascending order (i.e. from lowest number) */
  ValueAsc = 'Value_ASC',
  /** Sort by audit value in descending order (i.e. from highest number) */
  ValueDesc = 'Value_DESC',
}

/** Combined identification of audit */
export type AuditRef = {
  /** Plugin slug */
  plugin: Scalars['Slug']['input'];
  /** Audit slug */
  slug: Scalars['Slug']['input'];
};

/** Audit metadata and report */
export type AuditReport = {
  /** Description in Markdown */
  description?: InputMaybe<Scalars['Markdown']['input']>;
  /** Detailed info */
  details?: InputMaybe<AuditReportDetails>;
  /** Web link to audit's documentation */
  docsUrl?: InputMaybe<Scalars['URL']['input']>;
  /** Display value (e.g. '1.2 s' or '345 kB') */
  formattedValue?: InputMaybe<Scalars['String']['input']>;
  /** Score (0-1) */
  score: Scalars['Float']['input'];
  /** Slug */
  slug: Scalars['Slug']['input'];
  /** Display name */
  title: Scalars['String']['input'];
  /** Raw numeric value (in base unit, e.g. milliseconds or bytes) */
  value: Scalars['Float']['input'];
};

/** Details of audit report */
export type AuditReportDetails = {
  /** List of issues */
  issues?: InputMaybe<Array<AuditReportIssue>>;
  /** Additional data in table format */
  tables?: InputMaybe<Array<AuditReportTable>>;
  /** Additional data in tree format */
  trees?: InputMaybe<Array<AuditReportTree>>;
};

/** Issue listed in audit report */
export type AuditReportIssue = {
  /** Error message */
  message: Scalars['String']['input'];
  /** Severity level */
  severity: IssueSeverity;
  /** Column on line where issue ends (columns numbered from 1) */
  sourceEndColumn?: InputMaybe<Scalars['Int']['input']>;
  /** Line in file where issue ends (lines numbered from 1) */
  sourceEndLine?: InputMaybe<Scalars['Int']['input']>;
  /** Source file (full path from repository root) */
  sourceFilePath?: InputMaybe<Scalars['String']['input']>;
  /** Selector to locate the element on the page */
  sourceSelector?: InputMaybe<Scalars['String']['input']>;
  /** Code snippet of the element */
  sourceSnippet?: InputMaybe<Scalars['String']['input']>;
  /** Column on line where issue starts (columns numbered from 1) */
  sourceStartColumn?: InputMaybe<Scalars['Int']['input']>;
  /** Line in file where issue starts (lines numbered from 1) */
  sourceStartLine?: InputMaybe<Scalars['Int']['input']>;
  /** Discriminant for issue source */
  sourceType?: InputMaybe<IssueSourceType>;
  /** URL of the web page where the issue was found */
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Table in audit details */
export type AuditReportTable = {
  /** Column definitions */
  columns?: InputMaybe<Array<AuditReportTableColumn>>;
  /** Data rows */
  rows: Array<Array<AuditReportTableCell>>;
  /** Heading for display */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Table row cell */
export type AuditReportTableCell = {
  /** Display value */
  content: Scalars['String']['input'];
  /** Key for looking up column definition */
  key?: InputMaybe<Scalars['String']['input']>;
};

/** Table column */
export type AuditReportTableColumn = {
  /** Alignment of column */
  alignment?: InputMaybe<TableAlignment>;
  /** Key of corresponding row cell */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Display text for heading cell */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Tree in audit details */
export type AuditReportTree = {
  /** Root node */
  root: AuditReportTreeNode;
  /** Heading for display */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Discriminant */
  type: TreeType;
};

/** Tree node (basic or coverage) */
export type AuditReportTreeNode = {
  /** Child nodes */
  children?: InputMaybe<Array<AuditReportTreeNode>>;
  /** Coverage ratio (only for coverage trees) */
  coverage?: InputMaybe<Scalars['Float']['input']>;
  /** Lines of code with missing coverage (only for coverage trees) */
  missing?: InputMaybe<Array<AuditReportTreeNodeUncoveredLoc>>;
  /** Node display text (file/folder name for coverage trees) */
  name: Scalars['String']['input'];
  /** Custom node data (for basic trees) */
  values?: InputMaybe<Array<AuditReportTreeNodeValue>>;
};

/** Line range in source file with missing coverage (optionally referring to a specific function/class/etc.) */
export type AuditReportTreeNodeUncoveredLoc = {
  /** Column on line where issue ends (columns numbered from 1) */
  endColumn?: InputMaybe<Scalars['Int']['input']>;
  /** Line in file where issue ends (lines numbered from 1) */
  endLine?: InputMaybe<Scalars['Int']['input']>;
  /** Type of entity in code (function, class, etc.) */
  kind?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of function, class, etc. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Column on line where issue starts (columns numbered from 1) */
  startColumn?: InputMaybe<Scalars['Int']['input']>;
  /** Line in file where issue starts (lines numbered from 1) */
  startLine: Scalars['Int']['input'];
};

/** Basic tree node value */
export type AuditReportTreeNodeValue = {
  /** Identifier */
  key: Scalars['String']['input'];
  /** Display value */
  value: Scalars['String']['input'];
};

/** Number of audits with given status */
export type AuditStatusCount = {
  /** Number of audits */
  count: Scalars['Int']['output'];
  /** Status */
  status: AuditComparisonStatus;
};

/** How an audit's score/value changed over time */
export type AuditTrend = {
  /** Plugin slug */
  plugin: Scalars['Slug']['output'];
  /** How much has the score increased/decreased by? (if decreased, score will be negative) */
  scoreChange?: Maybe<Scalars['Float']['output']>;
  /** By what percentage has the score increased/decreased? (if decreased, score will be negative) */
  scoreChangePercentage?: Maybe<Scalars['Float']['output']>;
  /** Audit slug */
  slug: Scalars['Slug']['output'];
  /** How much has the value increased/decreased by? (if decreased, value will be negative) */
  valueChange?: Maybe<Scalars['Float']['output']>;
  /** By what percentage has the value increased/decreased? (if decreased, value will be negative) */
  valueChangePercentage?: Maybe<Scalars['Float']['output']>;
};

/** Filters for audit trends */
export type AuditTrendFilters = {
  /** Audits must belong to this category */
  category?: InputMaybe<Scalars['Slug']['input']>;
};

/** Comparing audits between reports */
export type AuditsComparison = {
  /** Single audit */
  audit?: Maybe<AuditComparison>;
  /** Audits from both reports */
  audits: AuditComparisonConnection;
  /** Basic stats with status counts */
  stats: AuditsComparisonStats;
};

/** Comparing audits between reports */
export type AuditsComparisonAuditArgs = {
  plugin: Scalars['Slug']['input'];
  slug: Scalars['Slug']['input'];
};

/** Comparing audits between reports */
export type AuditsComparisonAuditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuditComparisonFilters>;
};

/** Basic stats for comparing audits between reports */
export type AuditsComparisonStats = {
  /** Number of audits which are new, resolved, etc. */
  countsPerStatus: Array<AuditStatusCount>;
  /** Total number of audits from both reports */
  total: Scalars['Int']['output'];
};

/** Basic stats for included audits */
export type AuditsStats = {
  /** Number of audits with perfect score (1) */
  perfectScores: Scalars['Int']['output'];
  /** Number of audits */
  total: Scalars['Int']['output'];
};

/** Additional audit data in generic tree format */
export type BasicTree = Node & {
  /** Random ID */
  id: Scalars['ID']['output'];
  /** Root node of tree */
  root: BasicTreeNode;
  /** Display heading */
  title?: Maybe<Scalars['String']['output']>;
};

/** Node in basic tree */
export type BasicTreeNode = {
  /** Child nodes (if not leaf) */
  children?: Maybe<Array<BasicTreeNode>>;
  /** Text label */
  name: Scalars['String']['output'];
  /** Additional node data */
  values?: Maybe<Array<BasicTreeNodeValue>>;
};

/** Custom node value for basic tree */
export type BasicTreeNodeValue = {
  /** Identifier */
  key: Scalars['String']['output'];
  /** Display value */
  value: Scalars['String']['output'];
};

/** Git branch */
export type Branch = {
  /** Is this the repository's default branch? */
  isDefault: Scalars['Boolean']['output'];
  /** Branch name */
  name: Scalars['String']['output'];
  /** Link to branch in remote Git repo */
  url: Scalars['String']['output'];
};

/** Comparing categories between reports */
export type CategoriesComparison = {
  /** Categories from both reports */
  categories: Array<CategoryComparison>;
  /** Single category */
  category?: Maybe<CategoryComparison>;
  /** Basic stats with status counts */
  stats: CategoriesComparisonStats;
};

/** Comparing categories between reports */
export type CategoriesComparisonCategoriesArgs = {
  where?: InputMaybe<CategoryComparisonFilters>;
};

/** Comparing categories between reports */
export type CategoriesComparisonCategoryArgs = {
  slug: Scalars['Slug']['input'];
};

/** Basic stats for comparing categories between reports */
export type CategoriesComparisonStats = {
  /** Number of categories which are new, resolved, etc. */
  countsPerStatus: Array<CategoryStatusCount>;
  /** Total number of categories from both reports */
  total: Scalars['Int']['output'];
};

/** Category with report */
export type Category = Node & {
  /** Audits referenced by category */
  audits: AuditConnection;
  /** Number of audits */
  auditsCount: Scalars['Int']['output'];
  /** Description in Markdown */
  description?: Maybe<Scalars['Markdown']['output']>;
  /** Groups referenced by category */
  groups: Array<Group>;
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
  /** Issues' stats */
  issuesStats: IssuesStats;
  /** Audits and groups referenced by category, ordered by weight */
  refs: Array<CategoryRef>;
  /** Computed score */
  score: Scalars['Float']['output'];
  /** Pass/fail score threshold (0-1) for binary categories */
  scoreTarget?: Maybe<Scalars['Float']['output']>;
  /** Category slug */
  slug: Scalars['Slug']['output'];
  /** Display name */
  title: Scalars['String']['output'];
};

/** Category with report */
export type CategoryAuditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Category from report comparison */
export type CategoryComparison = Node & {
  /** Category from new report (missing if removed) */
  after?: Maybe<Category>;
  /** Category from old report (missing if added) */
  before?: Maybe<Category>;
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
  /** Audits and groups referenced by category and their changes */
  refs: CategoryComparisonRefConnection;
  /** Number of changed audits/group for given status */
  refsStatusChanges: Array<CategoryComparisonRefsStatusChange>;
  /** Status of category - improved/regressed/etc. */
  status: CategoryComparisonStatus;
  /** Changes to category score */
  trend?: Maybe<CategoryTrend>;
};

/** Category from report comparison */
export type CategoryComparisonRefsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters for categories from reports comparison */
export type CategoryComparisonFilters = {
  /** Only categories matching any of these statuses will be fetched */
  statuses?: InputMaybe<Array<CategoryComparisonStatus>>;
};

/** Weighted reference to audit or group from category comparison */
export type CategoryComparisonRef = Node & {
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
  /** Contribution to score as a percentage */
  percentage: Scalars['Float']['output'];
  /** Audit or group being referenced */
  target: AuditOrGroupComparison;
  /** Weight used to calculate score */
  weight: Scalars['Float']['output'];
};

/** Paginated audits or groups referenced by category (shape follows Relay spec) */
export type CategoryComparisonRefConnection = {
  /** Pagination items */
  edges: Array<CategoryComparisonRefEdge>;
  /** Pagination info */
  pageInfo: PageInfo;
};

/** Reference to audit or group referenced by category in page (shape follows Relay spec) */
export type CategoryComparisonRefEdge = {
  /** Pagination cursor */
  cursor: Scalars['String']['output'];
  /** Audit or group referenced by category */
  node: CategoryComparisonRef;
};

/** Number of audits/group with a given comparison status */
export type CategoryComparisonRefsStatusChange = {
  /** Number of audits/groups with this status */
  count: Scalars['Int']['output'];
  /** Status of audits/groups */
  status: AuditComparisonStatus;
  /** Discriminant between audit or group */
  type: CategoryConfigRefType;
};

/** Possibles states of category when comparing reports */
export enum CategoryComparisonStatus {
  /** Category is present in new report, but not old report */
  Added = 'Added',
  /** Category's score went up */
  Improved = 'Improved',
  /** Category's score went down */
  Regressed = 'Regressed',
  /** Category is present in old report, but not new report */
  Removed = 'Removed',
  /** Category's score is unchanged */
  Unchanged = 'Unchanged',
}

/** Category configuration */
export type CategoryConfig = {
  /** Description in Markdown */
  description?: InputMaybe<Scalars['Markdown']['input']>;
  /** Weighted references to audits and groups for calculating score */
  refs: Array<CategoryConfigRef>;
  /** Pass/fail score threshold (0-1) for binary categories */
  scoreTarget?: InputMaybe<Scalars['Float']['input']>;
  /** Slug */
  slug: Scalars['Slug']['input'];
  /** Display name */
  title: Scalars['String']['input'];
};

/** Weighted reference to audit or group */
export type CategoryConfigRef = {
  /** Plugin slug */
  plugin: Scalars['Slug']['input'];
  /** Audit or group slug */
  slug: Scalars['Slug']['input'];
  /** Discriminant between audit or group */
  type: CategoryConfigRefType;
  /** Multiplier used to calculate category score as weighted average */
  weight: Scalars['Float']['input'];
};

/** What is being referenced in category config */
export enum CategoryConfigRefType {
  /** Reference to audit (via slug) */
  Audit = 'Audit',
  /** Reference to group of audits (via slug) */
  Group = 'Group',
}

/** Weighted reference to audit or group from category */
export type CategoryRef = {
  /** Audit or group being referenced */
  target: AuditOrGroup;
  /** Weight used to calculate score */
  weight: Scalars['Float']['output'];
};

/** Number of categories with given status */
export type CategoryStatusCount = {
  /** Number of categories */
  count: Scalars['Int']['output'];
  /** Status */
  status: CategoryComparisonStatus;
};

/** How a category's score changed over time */
export type CategoryTrend = {
  /** How much has the score increased/decreased by? (if decreased, score will be negative) */
  scoreChange?: Maybe<Scalars['Float']['output']>;
  /** By what percentage has the score increased/decreased? (if decreased, score will be negative) */
  scoreChangePercentage?: Maybe<Scalars['Float']['output']>;
  /** Category slug */
  slug: Scalars['Slug']['output'];
};

/** Git commit */
export type Commit = {
  /** Author of commit */
  author?: Maybe<CommitAuthor>;
  /** Date committed */
  date?: Maybe<Scalars['Date']['output']>;
  /** Has analysis been completed for this commit? */
  hasReport: Scalars['Boolean']['output'];
  /** Commit message */
  message: Scalars['String']['output'];
  /** Report of analysis for this commit (if available) */
  report?: Maybe<Report>;
  /** Commit's unique SHA-1 hash (unabbreviated) */
  sha: Scalars['CommitSHA']['output'];
  /** Git tags */
  tags: Array<Tag>;
  /** Link to commit in remote Git repo */
  url: Scalars['String']['output'];
};

/** Git commit */
export type CommitMessageArgs = {
  firstLineOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Author of Git commit */
export type CommitAuthor = {
  /** Image URL for author's avatar (from remote Git provider) */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** E-mail address (configured in Git) */
  email: Scalars['String']['output'];
  /** Name (configured in Git) */
  name: Scalars['String']['output'];
};

/** A pair of commits being compared */
export type CommitComparison = {
  /** Git commit for new state */
  after: Commit;
  /** Git commit for old state */
  before: Commit;
};

/** Additional audit coverage data in tree format */
export type CoverageTree = Node & {
  /** Random ID */
  id: Scalars['ID']['output'];
  /** Root node of tree */
  root: CoverageTreeNode;
  /** Display heading */
  title?: Maybe<Scalars['String']['output']>;
};

/** Node in coverage tree */
export type CoverageTreeNode = {
  /** Files/folders contained by folder (not applicable for file) */
  children?: Maybe<Array<CoverageTreeNode>>;
  /** File or folder name */
  name: Scalars['String']['output'];
  /** Coverage metrics */
  values: CoverageTreeNodeValues;
};

/** Coverage metrics for file/folder */
export type CoverageTreeNodeValues = {
  /** Coverage ratio (0-1) */
  coverage: Scalars['Float']['output'];
  /** Lines of code with missing coverage (for files only) */
  missing?: Maybe<Array<UncoveredLoc>>;
};

/** Sign-in method based on allowed emails */
export type EmailSignInMethod = Node &
  SignInMethod & {
    /** List of allowed emails (e.g. 'john.doe@example.com') or email domains (e.g. '*@example.com') */
    allowedEmails: Array<Scalars['Email']['output']>;
    /** Unique ID (for caching) */
    id: Scalars['ID']['output'];
  };

/** Payload for an organization's sign-in method */
export type EnabledSignInMethod = {
  /** List of allowed emails or domains (only for variant: Email) */
  allowedEmails?: InputMaybe<Array<Scalars['Email']['input']>>;
  /** Discriminant */
  variant: SignInMethodVariant;
};

/** GitHub App installation */
export type GitHubApp = {
  /** Unique identifier assigned to the GitHub App */
  id: Scalars['ID']['output'];
  /** Display name of the GitHub App */
  name: Scalars['String']['output'];
  /** URL to the GitHub App on GitHub */
  webUrl: Scalars['URL']['output'];
};

/** Authenticated GitHub provider instance that contains information about the connected GitHub App and available repositories */
export type GitHubProvider = {
  /** Authenticated GitHub App information */
  app?: Maybe<GitHubApp>;
  /** List of repositories that the GitHub App has access to */
  repositories: Array<GitHubRepository>;
};

/** GitHub repository */
export type GitHubRepository = Node &
  Repository & {
    /** Repository contents (null if the repository is unauthorized) */
    contents?: Maybe<RepositoryContents>;
    /** Unique ID (for caching) */
    id: Scalars['ID']['output'];
    /** Repository owner (GitHub user or organization) */
    owner: Scalars['String']['output'];
    /** Connected GitHub projects */
    projects: Array<Maybe<Project>>;
    /** Repository name */
    repo: Scalars['String']['output'];
  };

/** GitLab group that contains one or more related projects */
export type GitLabGroup = {
  /** Display name of the GitLab group */
  name: Scalars['String']['output'];
  /** Unique path of the GitLab group */
  path: Scalars['String']['output'];
  /** URL to the GitLab group page */
  webUrl: Scalars['URL']['output'];
};

/** Access token that grants access to projects within a GitLab group */
export type GitLabGroupAccessToken = {
  /** Group associated with the group-level access token */
  group: GitLabGroup;
};

/** Personal access token for GitLab authentication */
export type GitLabPersonalAccessToken = {
  /** User associated with the personal access token */
  user: GitLabUser;
};

/** Access token that grants access to a specific GitLab project */
export type GitLabProjectAccessToken = {
  /** Repository associated with the project-level access token */
  repository: GitLabRepository;
};

/** Authenticated GitLab provider instance that contains authentication details and accessible repositories */
export type GitLabProvider = {
  /** Repositories accessible to the authenticated GitLab user */
  repositories: Array<GitLabRepository>;
  /** Authentication token details for GitLab, used to verify the user's identity */
  token: GitLabToken;
};

/** Authenticated GitLab provider instance that contains authentication details and accessible repositories */
export type GitLabProviderRepositoriesArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  visibility?: GitLabVisibility;
};

/** GitLab repository */
export type GitLabRepository = Node &
  Repository & {
    /** Repository contents (null if the repository is unauthorized) */
    contents?: Maybe<RepositoryContents>;
    /** Unique ID (for caching) */
    id: Scalars['ID']['output'];
    /** Repository owner (GitLab user or organization) */
    owner: Scalars['String']['output'];
    /** Connected GitLab projects */
    projects: Array<Maybe<Project>>;
    /** Repository name (GitLab project) */
    repo: Scalars['String']['output'];
  };

/** Personal access token for a GitLab service account */
export type GitLabServiceAccountToken = {
  /** User account associated with the service account token */
  user: GitLabUser;
};

/** Authentication token for GitLab */
export type GitLabToken =
  | GitLabGroupAccessToken
  | GitLabPersonalAccessToken
  | GitLabProjectAccessToken
  | GitLabServiceAccountToken;

/** Individual GitLab user */
export type GitLabUser = {
  /** Email address associated with the GitLab user */
  email: Scalars['String']['output'];
  /** Unique identifier assigned to the GitLab user */
  id: Scalars['ID']['output'];
  /** Is human user or a service account? */
  isBot: Scalars['Boolean']['output'];
  /** Full name of the GitLab user */
  name: Scalars['String']['output'];
  /** Username of the GitLab user */
  username: Scalars['String']['output'];
  /** URL to the GitLab user profile */
  webUrl: Scalars['URL']['output'];
};

/** Visibility levels for GitLab repositories that determine who can access a repository */
export enum GitLabVisibility {
  /** Internal repositories are accessible within the organization */
  Internal = 'Internal',
  /** Private repositories are only accessible to authorized users */
  Private = 'Private',
  /** Public repositories are open to everyone */
  Public = 'Public',
}

/** Available Git providers (GitHub and GitLab) */
export type GitProviders = {
  /** GitHub provider information, null if not configured */
  github?: Maybe<GitHubProvider>;
  /** GitLab provider information, null if not configured */
  gitlab?: Maybe<GitLabProvider>;
};

/** Repository type */
export enum GitRepositoryProvider {
  /** GitHub */
  GitHub = 'GitHub',
  /** GitLab */
  GitLab = 'GitLab',
}

/** Pre-defined user permission set - global scope */
export enum GlobalRole {
  /** Super-admin */
  SuperAdmin = 'SuperAdmin',
}

/** Role assigned to user globally */
export type GlobalUserRole = {
  /** Role */
  role: GlobalRole;
};

/** Group with report */
export type Group = Node & {
  /** Audits referenced by group */
  audits: AuditConnection;
  /** Number of audits */
  auditsCount: Scalars['Int']['output'];
  /** Categories which reference this group */
  categories: Array<Category>;
  /** Usage in categories as percentage */
  contributions: GroupContributions;
  /** Description in Markdown */
  description?: Maybe<Scalars['Markdown']['output']>;
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
  /** Plugin where this group originates */
  plugin: Plugin;
  /** Audits referenced by group, ordered by weight */
  refs: Array<GroupRef>;
  /** Computed score */
  score: Scalars['Float']['output'];
  /** Group slug */
  slug: Scalars['Slug']['output'];
  /** Display name */
  title: Scalars['String']['output'];
};

/** Group with report */
export type GroupAuditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Group's percentage in category */
export type GroupCategoryContribution = {
  /** Category */
  category: Category;
  /** Percentage calculated from weights */
  percentage: Scalars['Float']['output'];
};

/** Group from report comparison */
export type GroupComparison = Node & {
  /** Group from new report (missing if removed) */
  after?: Maybe<Group>;
  /** Group from old report (missing if added) */
  before?: Maybe<Group>;
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
  /** Audits referenced by group and their changes */
  refs: GroupComparisonRefConnection;
  /** Status of group - improved/regressed/etc. */
  status: GroupComparisonStatus;
  /** Changes to group score */
  trend?: Maybe<GroupTrend>;
};

/** Group from report comparison */
export type GroupComparisonRefsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Paginated group comparisons (shape follows Relay spec) */
export type GroupComparisonConnection = {
  /** Pagination items */
  edges: Array<GroupComparisonEdge>;
  /** Pagination info */
  pageInfo: PageInfo;
};

/** Reference to group comparison in page (shape follows Relay spec) */
export type GroupComparisonEdge = {
  /** Pagination cursor */
  cursor: Scalars['String']['output'];
  /** GroupComparison */
  node: GroupComparison;
};

/** Filters for groups from reports comparison */
export type GroupComparisonFilters = {
  /** Only groups refenced by any of these categories will be fetched */
  categories?: InputMaybe<Array<Scalars['Slug']['input']>>;
  /** Only groups matching any of these statuses will be fetched */
  statuses?: InputMaybe<Array<GroupComparisonStatus>>;
};

/** Weighted reference to audit from group comparison */
export type GroupComparisonRef = Node & {
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
  /** Contribution to score as a percentage */
  percentage: Scalars['Float']['output'];
  /** Audit being referenced */
  target: AuditComparison;
  /** Weight used to calculate score */
  weight: Scalars['Float']['output'];
};

/** Paginated audits referenced by group (shape follows Relay spec) */
export type GroupComparisonRefConnection = {
  /** Pagination items */
  edges: Array<GroupComparisonRefEdge>;
  /** Pagination info */
  pageInfo: PageInfo;
};

/** Reference to audit referenced by group in page (shape follows Relay spec) */
export type GroupComparisonRefEdge = {
  /** Pagination cursor */
  cursor: Scalars['String']['output'];
  /** Audit referenced by group */
  node: GroupComparisonRef;
};

/** Possibles states of group when comparing reports */
export enum GroupComparisonStatus {
  /** Group is present in new report, but not old report */
  Added = 'Added',
  /** Group's score went up */
  Improved = 'Improved',
  /** Group's score went down */
  Regressed = 'Regressed',
  /** Group is present in old report, but not new report */
  Removed = 'Removed',
  /** Group's score is unchanged */
  Unchanged = 'Unchanged',
}

/** Group configuration */
export type GroupConfig = {
  /** Description in Markdown */
  description?: InputMaybe<Scalars['Markdown']['input']>;
  /** Weighted references to audits for calculating score */
  refs: Array<GroupConfigAuditRef>;
  /** Human-readable ID (URL-safe) */
  slug: Scalars['Slug']['input'];
  /** Display name */
  title: Scalars['String']['input'];
};

/** Weighted reference to audit */
export type GroupConfigAuditRef = {
  /** Audit slug */
  slug: Scalars['Slug']['input'];
  /** Multiplier used to calculate group score as weighted average */
  weight: Scalars['Float']['input'];
};

/** Group's usage in categories as percentage */
export type GroupContributions = {
  /** Categories which reference group */
  categories: Array<GroupCategoryContribution>;
};

/** Weighted reference to audit from group */
export type GroupRef = {
  /** Audit being referenced */
  target: Audit;
  /** Weight used to calculate score */
  weight: Scalars['Float']['output'];
};

/** Number of groups with given status */
export type GroupStatusCount = {
  /** Number of groups */
  count: Scalars['Int']['output'];
  /** Status */
  status: GroupComparisonStatus;
};

/** How a group's score changed over time */
export type GroupTrend = {
  /** Plugin slug */
  plugin: Scalars['Slug']['output'];
  /** How much has the score increased/decreased by? (if decreased, score will be negative) */
  scoreChange?: Maybe<Scalars['Float']['output']>;
  /** By what percentage has the score increased/decreased? (if decreased, score will be negative) */
  scoreChangePercentage?: Maybe<Scalars['Float']['output']>;
  /** Group slug */
  slug: Scalars['Slug']['output'];
};

/** Comparing groups between reports */
export type GroupsComparison = {
  /** Single group */
  group?: Maybe<GroupComparison>;
  /** Groups from both reports */
  groups: GroupComparisonConnection;
  /** Basic stats with status counts */
  stats: GroupsComparisonStats;
};

/** Comparing groups between reports */
export type GroupsComparisonGroupArgs = {
  plugin: Scalars['Slug']['input'];
  slug: Scalars['Slug']['input'];
};

/** Comparing groups between reports */
export type GroupsComparisonGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GroupComparisonFilters>;
};

/** Basic stats for comparing groups between reports */
export type GroupsComparisonStats = {
  /** Number of groups which are new, resolved, etc. */
  countsPerStatus: Array<GroupStatusCount>;
  /** Total number of groups from both reports */
  total: Scalars['Int']['output'];
};

/** Issue found in analysis */
export type Issue = Node & {
  /** Audit where this issue originated */
  audit: Audit;
  /** Categories which reference the audit */
  categories: Array<Category>;
  /** Git commit */
  commit: Commit;
  /** Random ID */
  id: Scalars['ID']['output'];
  /** Error message */
  message: Scalars['String']['output'];
  /** Git repo */
  repository: Repository;
  /** Severity level */
  severity: IssueSeverity;
  /** Link to issue source */
  source?: Maybe<IssueSource>;
};

/** Filters for issues from reports comparison */
export type IssueComparisonFilters = {
  /** Only issues matching this status will be fetched */
  status: IssueComparisonStatus;
};

/** Possible status of issues when comparing reports */
export enum IssueComparisonStatus {
  /** Issue belongs to audit present in new report, but not old report */
  Added = 'Added',
  /** Issue's present in new report, but not old report (audit in both) */
  New = 'New',
  /** Issue belongs to audit present in old report, but not new report */
  Removed = 'Removed',
  /** Issue's present in old report, but not new report (audit in both) */
  Resolved = 'Resolved',
  /** Issue's present in both old and new reports */
  Unchanged = 'Unchanged',
}

/** Paginated analysis issues (shape follows Relay spec) */
export type IssueConnection = {
  /** Pagination items */
  edges: Array<IssueEdge>;
  /** Pagination info */
  pageInfo: PageInfo;
};

/** Reference to analysis issue in page (shape follows Relay spec) */
export type IssueEdge = {
  /** Pagination cursor */
  cursor: Scalars['String']['output'];
  /** Issue */
  node: Issue;
};

/** Filters for analysis issues (no more than one clause at a time is supported) */
export type IssueFilters = {
  /** Issues must originate in these audits */
  audits?: InputMaybe<Array<AuditRef>>;
  /** Issues must match these categories */
  categories?: InputMaybe<Array<Scalars['Slug']['input']>>;
  /** Issues must be in these files or directories */
  sourceCodePaths?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Issues must be reported on these URLs */
  sourceUrls?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Sort order for analysis issues */
export enum IssueOrder {
  /** Sort by audit name in ascending order (i.e. alphabetical) */
  AuditAsc = 'Audit_ASC',
  /** Sort by audit name in descending order (i.e. reverse alphabetical) */
  AuditDesc = 'Audit_DESC',
  /** Sort by error message in ascending order (i.e. alphabetical) */
  MessageAsc = 'Message_ASC',
  /** Sort by error message in descending order (i.e. reverse alphabetical) */
  MessageDesc = 'Message_DESC',
  /** Sort by severity in ascending order (i.e. from least to most severe, or alphabetical for legacy reports) */
  SeverityAsc = 'Severity_ASC',
  /** Sort by severity in descending order (i.e. from most to least severe, or reverse alphabetical for legacy reports) */
  SeverityDesc = 'Severity_DESC',
  /** Sort by source in ascending order (i.e. alphabetical) */
  SourceAsc = 'Source_ASC',
  /** Sort by source in descending order (i.e. reverse alphabetical) */
  SourceDesc = 'Source_DESC',
}

/** Severity level of an issue */
export enum IssueSeverity {
  /** Error */
  Error = 'Error',
  /** Informational */
  Info = 'Info',
  /** Warning */
  Warning = 'Warning',
}

/** Number of issues of given severity */
export type IssueSeverityCount = {
  /** Number of issues */
  count: Scalars['Int']['output'];
  /** Severity level */
  severity: IssueSeverity;
};

/** Source of an issue */
export type IssueSource = SourceCodeLocation | SourceUrlLocation;

/** Type of issue source */
export enum IssueSourceType {
  /** File snippet in source code */
  SourceCode = 'SourceCode',
  /** Element on a web page */
  Url = 'Url',
}

/** Number of issues with given status */
export type IssueStatusCount = {
  /** Number of issues */
  count: Scalars['Int']['output'];
  /** Status */
  status: IssueComparisonStatus;
};

/** Full comparison of issues between reports */
export type IssuesComparison = {
  /** Issues with given status */
  issues: IssueConnection;
  /** Comparing issue counts between reports */
  stats: IssuesComparisonStats;
};

/** Full comparison of issues between reports */
export type IssuesComparisonIssuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueOrder>;
  where: IssueComparisonFilters;
};

/** Basic stats for comparing issues between reports */
export type IssuesComparisonStats = {
  /** Number of issues which are new, resolved, etc. */
  countsPerStatus: Array<IssueStatusCount>;
  /** Difference between total counts */
  totalChange: Scalars['Int']['output'];
};

/** Basic stats for detected issues */
export type IssuesStats = {
  /** Number of issues for each severity */
  countsPerSeverity: Array<IssueSeverityCount>;
  /** Number of issues */
  total: Scalars['Int']['output'];
};

/** Git repository */
export type LinkedRepository = {
  /** GitHub owner or GitLab group path */
  owner: Scalars['String']['input'];
  /** Type of repository */
  provider: GitRepositoryProvider;
  /** GitHub repo or GitLab project slug */
  repo: Scalars['String']['input'];
};

/** Pre-defined user permission set - organization/project scope */
export enum LocalRole {
  /** Maintainer */
  Maintainer = 'Maintainer',
  /** Owner */
  Owner = 'Owner',
  /** Viewer */
  Viewer = 'Viewer',
}

/** Root mutations */
export type Mutation = {
  /** Block user in organization or projects */
  blockUser: User;
  /** Create a new organization */
  createOrganization: Organization;
  /** Create a new project (in an existing organization) */
  createProject: Project;
  /** Delete API key */
  deleteApiKey?: Maybe<Scalars['Boolean']['output']>;
  /** Delete an organization, with all its projects and reports */
  deleteOrganization?: Maybe<Scalars['Boolean']['output']>;
  /** Delete an existing project, with all its reports */
  deleteProject?: Maybe<Scalars['Boolean']['output']>;
  /** Create API key (cannot be retrieved after this mutation) */
  generateApiKey: ApiKey;
  /** Send invitation email to (authorized) user and update their role in organization/project */
  inviteUser: User;
  /** Sign in user using HOTP from sign-in link */
  login: UserTokens;
  /** Get new access and refresh tokens */
  refreshTokens: UserTokens;
  /** Update organization name */
  renameOrganization: Organization;
  /** Update sign-in methods for organization */
  replaceOrganizationSignInMethods: Organization;
  /** Update list of users with super-admin role (all affected users listed in response) */
  replaceSuperAdminUsers: Array<User>;
  /** Upload analysis report */
  saveReport: Report;
  /** Contact us via email form message */
  sendContactUsEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Send sign-in link to provided email address */
  sendEmailSignInLink?: Maybe<Scalars['Boolean']['output']>;
  /** Add or remove project to/from favorites (requires user authentication) */
  setFavoriteProject: Project;
  /** Unblock user in organization or projects */
  unblockUser: User;
  /** Update an existing project */
  updateProject: Project;
  /** Replace user's roles within organization and its projects */
  updateUserRolesInOrganization: User;
};

/** Root mutations */
export type MutationBlockUserArgs = {
  email: Scalars['Email']['input'];
  organization: Scalars['Slug']['input'];
  projects?: InputMaybe<Array<Scalars['Slug']['input']>>;
};

/** Root mutations */
export type MutationCreateOrganizationArgs = {
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  signInMethods: Array<EnabledSignInMethod>;
  slug: Scalars['Slug']['input'];
};

/** Root mutations */
export type MutationCreateProjectArgs = {
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  organization: Scalars['Slug']['input'];
  repository: LinkedRepository;
  slug: Scalars['Slug']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Root mutations */
export type MutationDeleteApiKeyArgs = {
  apiKeyId: Scalars['String']['input'];
  organization: Scalars['Slug']['input'];
  project?: InputMaybe<Scalars['Slug']['input']>;
};

/** Root mutations */
export type MutationDeleteOrganizationArgs = {
  slug: Scalars['Slug']['input'];
};

/** Root mutations */
export type MutationDeleteProjectArgs = {
  organization: Scalars['Slug']['input'];
  project: Scalars['Slug']['input'];
};

/** Root mutations */
export type MutationGenerateApiKeyArgs = {
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  organization: Scalars['Slug']['input'];
  project?: InputMaybe<Scalars['Slug']['input']>;
  scope: Scope;
};

/** Root mutations */
export type MutationInviteUserArgs = {
  email: Scalars['Email']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  organization: Scalars['Slug']['input'];
  project?: InputMaybe<Scalars['Slug']['input']>;
  role: LocalRole;
};

/** Root mutations */
export type MutationLoginArgs = {
  email: Scalars['Email']['input'];
  hotp: Scalars['String']['input'];
};

/** Root mutations */
export type MutationRefreshTokensArgs = {
  refreshToken: Scalars['String']['input'];
};

/** Root mutations */
export type MutationRenameOrganizationArgs = {
  friendlyName: Scalars['String']['input'];
  slug: Scalars['Slug']['input'];
};

/** Root mutations */
export type MutationReplaceOrganizationSignInMethodsArgs = {
  organization: Scalars['Slug']['input'];
  signInMethods: Array<EnabledSignInMethod>;
};

/** Root mutations */
export type MutationReplaceSuperAdminUsersArgs = {
  emails: Array<Scalars['Email']['input']>;
};

/** Root mutations */
export type MutationSaveReportArgs = {
  categories: Array<CategoryConfig>;
  commandDuration?: InputMaybe<Scalars['Int']['input']>;
  commandStartDate?: InputMaybe<Scalars['Date']['input']>;
  commit: Scalars['CommitSHA']['input'];
  organization: Scalars['Slug']['input'];
  packageName?: InputMaybe<Scalars['NpmPackageName']['input']>;
  packageVersion?: InputMaybe<Scalars['NpmPackageVersion']['input']>;
  plugins: Array<PluginReport>;
  project: Scalars['Slug']['input'];
};

/** Root mutations */
export type MutationSendContactUsEmailArgs = {
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Root mutations */
export type MutationSendEmailSignInLinkArgs = {
  email: Scalars['Email']['input'];
};

/** Root mutations */
export type MutationSetFavoriteProjectArgs = {
  isFavorite?: Scalars['Boolean']['input'];
  organization: Scalars['Slug']['input'];
  project: Scalars['Slug']['input'];
};

/** Root mutations */
export type MutationUnblockUserArgs = {
  email: Scalars['Email']['input'];
  organization: Scalars['Slug']['input'];
  projects?: InputMaybe<Array<Scalars['Slug']['input']>>;
};

/** Root mutations */
export type MutationUpdateProjectArgs = {
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  organization: Scalars['Slug']['input'];
  project: Scalars['Slug']['input'];
  repository?: InputMaybe<LinkedRepository>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Root mutations */
export type MutationUpdateUserRolesInOrganizationArgs = {
  email: Scalars['Email']['input'];
  organization: Scalars['Slug']['input'];
  roles: Array<RoleWithinOrganization>;
};

/** Generic node (based on Relay spec) */
export type Node = {
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
};

/** Stages of onboarding based on existing organizations and their projects */
export enum OnboardingStatus {
  /** No organizations found */
  NotOnboarded = 'NotOnboarded',
  /** At least one organization contains one or more projects */
  Onboarded = 'Onboarded',
  /** At least one organization exists, but none contain any projects */
  OrganizationOnly = 'OrganizationOnly',
}

/** Organization */
export type Organization = Node & {
  /** API keys with access to organization */
  apiKeys: Array<ApiKeyMetadata>;
  /** Custom display name */
  friendlyName?: Maybe<Scalars['String']['output']>;
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
  /** Projects belonging to organization */
  projects: Array<Project>;
  /** All enabled sign in methods (which user has access to) */
  signInMethods: Array<SignInMethod>;
  /** Slug */
  slug: Scalars['Slug']['output'];
  /** Users with access to (or blocked in) organization */
  users: Array<User>;
};

/** Organization */
export type OrganizationUsersArgs = {
  roleType?: InputMaybe<UserRoleType>;
};

/** Role assigned to user in organization */
export type OrganizationUserRole = {
  /** Organization */
  organization: Organization;
  /** Role */
  role: LocalRole;
};

/** Pagination metadata */
export type PageInfo = {
  /** Pagination cursor of last item */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Are there any subsequent items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** Are there any preceding items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Pagination cursor of first item */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Plugin with report */
export type Plugin = Node & {
  /** Audits defined by plugin */
  audits: AuditConnection;
  /** Number of audits */
  auditsCount: Scalars['Int']['output'];
  /** Description in Markdown */
  description?: Maybe<Scalars['Markdown']['output']>;
  /** Web link to plugin's documentation */
  docsUrl?: Maybe<Scalars['URL']['output']>;
  /** Groups defined by plugin */
  groups: Array<Group>;
  /** Number of groups */
  groupsCount: Scalars['Int']['output'];
  /** Icon used to visually identify plugin */
  icon: Scalars['MaterialIcon']['output'];
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
  /** NPM package name */
  packageName?: Maybe<Scalars['NpmPackageName']['output']>;
  /** NPM package version */
  packageVersion?: Maybe<Scalars['NpmPackageVersion']['output']>;
  /** How long plugin runner took (in milliseconds) */
  runnerDuration?: Maybe<Scalars['Int']['output']>;
  /** When plugin runner was started */
  runnerStartDate?: Maybe<Scalars['Date']['output']>;
  /** Plugin slug */
  slug: Scalars['Slug']['output'];
  /** Display name */
  title: Scalars['String']['output'];
};

/** Plugin with report */
export type PluginAuditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Plugin metadata and report */
export type PluginReport = {
  /** Audit configurations and reports */
  audits: Array<AuditReport>;
  /** Description in Markdown */
  description?: InputMaybe<Scalars['Markdown']['input']>;
  /** Web link to plugin's documentation */
  docsUrl?: InputMaybe<Scalars['URL']['input']>;
  /** Group configurations */
  groups?: InputMaybe<Array<GroupConfig>>;
  /** Icon used to visually identify plugin */
  icon: Scalars['MaterialIcon']['input'];
  /** NPM package name */
  packageName?: InputMaybe<Scalars['NpmPackageName']['input']>;
  /** NPM package version */
  packageVersion?: InputMaybe<Scalars['NpmPackageVersion']['input']>;
  /** How long plugin runner took (in milliseconds) */
  runnerDuration?: InputMaybe<Scalars['Int']['input']>;
  /** When plugin runner was started */
  runnerStartDate?: InputMaybe<Scalars['Date']['input']>;
  /** Slug */
  slug: Scalars['Slug']['input'];
  /** Display name */
  title: Scalars['String']['input'];
};

/** Basic stats for included plugins */
export type PluginsStats = {
  /** Number of plugins */
  total: Scalars['Int']['output'];
};

/** Project */
export type Project = Node & {
  /** Custom display name */
  friendlyName?: Maybe<Scalars['String']['output']>;
  /** Does this project have any reports? */
  hasReports: Scalars['Boolean']['output'];
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
  /** Has authenticated user favorited this project? (null if authorized via API key) */
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  /** Latest analysis report for default branch (checks older commits as well) */
  latestReport?: Maybe<Report>;
  /** Organization project belongs to */
  organization: Organization;
  /** Analysis report for given version (identified by branch or commit) */
  report?: Maybe<Report>;
  /** Diff between reports for given Git refs */
  reportComparison?: Maybe<ReportComparison>;
  /** Analysis reports for given date range (max 90 days) */
  reports?: Maybe<Array<Report>>;
  /** Analysis reports trend over given date range (max 90 days) */
  reportsTrend?: Maybe<ReportsTrend>;
  /** Git repository */
  repository: Repository;
  /** Slug */
  slug: Scalars['Slug']['output'];
  /** Custom project tags */
  tags: Array<Scalars['String']['output']>;
  /** Users with access to (or blocked in) project */
  users: Array<User>;
};

/** Project */
export type ProjectLatestReportArgs = {
  maxCommits?: InputMaybe<Scalars['Int']['input']>;
};

/** Project */
export type ProjectReportArgs = {
  branch?: InputMaybe<Scalars['String']['input']>;
  commit?: InputMaybe<Scalars['CommitSHA']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

/** Project */
export type ProjectReportComparisonArgs = {
  after: Scalars['String']['input'];
  before: Scalars['String']['input'];
};

/** Project */
export type ProjectReportsArgs = {
  branch?: InputMaybe<Scalars['String']['input']>;
  commit?: InputMaybe<Scalars['CommitSHA']['input']>;
  since?: InputMaybe<Scalars['Date']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['Date']['input']>;
};

/** Project */
export type ProjectReportsTrendArgs = {
  branch?: InputMaybe<Scalars['String']['input']>;
  commit?: InputMaybe<Scalars['CommitSHA']['input']>;
  since?: InputMaybe<Scalars['Date']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['Date']['input']>;
};

/** Project */
export type ProjectUsersArgs = {
  roleType?: InputMaybe<UserRoleType>;
};

/** Project tag with usage count */
export type ProjectTagCount = {
  /** Number of projects using this tag */
  count: Scalars['Int']['output'];
  /** Tag name */
  tag: Scalars['String']['output'];
};

/** Role assigned to user in project */
export type ProjectUserRole = {
  /** Project */
  project: Project;
  /** Role */
  role: LocalRole;
};

/** Root queries */
export type Query = {
  /** Available GitHub and GitLab repositories for the authenticated user */
  gitProviders: GitProviders;
  /** Have any organizations been created for this portal instance? */
  hasOrganizations: Scalars['Boolean']['output'];
  /** Fetches a single node by its node ID (based on Relay spec) */
  node?: Maybe<Node>;
  /** Onboarding status */
  onboardingStatus: OnboardingStatus;
  /** Specific organization */
  organization?: Maybe<Organization>;
  /** All organizations (which user has access to) */
  organizations: Array<Organization>;
  /** Specific project in organization */
  project?: Maybe<Project>;
  /** Aggregated project tags sorted by count (descending) and name (ascending) */
  projectTags: Array<ProjectTagCount>;
  /** All projects in organization */
  projects: Array<Project>;
  /** Analysis report for given project version (identified by branch or commit) */
  report?: Maybe<Report>;
  /** Analysis reports for project in given date range */
  reports?: Maybe<Array<Report>>;
};

/** Root queries */
export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};

/** Root queries */
export type QueryOrganizationArgs = {
  organization: Scalars['Slug']['input'];
};

/** Root queries */
export type QueryProjectArgs = {
  organization: Scalars['Slug']['input'];
  project: Scalars['Slug']['input'];
};

/** Root queries */
export type QueryProjectsArgs = {
  organization?: InputMaybe<Scalars['Slug']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Root queries */
export type QueryReportArgs = {
  branch?: InputMaybe<Scalars['String']['input']>;
  commit?: InputMaybe<Scalars['CommitSHA']['input']>;
  organization: Scalars['Slug']['input'];
  project: Scalars['Slug']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
};

/** Root queries */
export type QueryReportsArgs = {
  branch?: InputMaybe<Scalars['String']['input']>;
  commit?: InputMaybe<Scalars['CommitSHA']['input']>;
  organization: Scalars['Slug']['input'];
  project: Scalars['Slug']['input'];
  since?: InputMaybe<Scalars['Date']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['Date']['input']>;
};

/** Analysis report (for a given version of Git repository) */
export type Report = Node & {
  /** Single audit */
  audit?: Maybe<Audit>;
  /** All audits */
  audits: AuditConnection;
  /** All categories */
  categories: Array<Category>;
  /** Single category */
  category?: Maybe<Category>;
  /** How long CLI command took (in milliseconds) */
  commandDuration?: Maybe<Scalars['Int']['output']>;
  /** When was CLI command started */
  commandStartDate?: Maybe<Scalars['Date']['output']>;
  /** Git commit */
  commit: Commit;
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
  /** Issues found during analysis (from different audits) */
  issues: IssueConnection;
  /** CLI's NPM package name */
  packageName?: Maybe<Scalars['NpmPackageName']['output']>;
  /** CLI's NPM package version */
  packageVersion?: Maybe<Scalars['NpmPackageVersion']['output']>;
  /** Single plugin */
  plugin?: Maybe<Plugin>;
  /** All plugins */
  plugins: Array<Plugin>;
  /** Project */
  project: Project;
  /** Git repo */
  repository: Repository;
  /** Source files referenced by issues in report */
  sourceFiles: Array<Scalars['String']['output']>;
  /** Source URLs referenced by issues in report */
  sourceUrls: Array<Scalars['String']['output']>;
  /** Basic stats */
  stats: ReportStats;
  /** Web link to report in portal */
  url: Scalars['URL']['output'];
};

/** Analysis report (for a given version of Git repository) */
export type ReportAuditArgs = {
  plugin: Scalars['Slug']['input'];
  slug: Scalars['Slug']['input'];
};

/** Analysis report (for a given version of Git repository) */
export type ReportAuditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AuditOrder>;
  where?: InputMaybe<AuditFilters>;
};

/** Analysis report (for a given version of Git repository) */
export type ReportCategoryArgs = {
  slug: Scalars['Slug']['input'];
};

/** Analysis report (for a given version of Git repository) */
export type ReportIssuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueOrder>;
  where?: InputMaybe<IssueFilters>;
};

/** Analysis report (for a given version of Git repository) */
export type ReportPluginArgs = {
  slug: Scalars['Slug']['input'];
};

/** Diff between two different reports */
export type ReportComparison = Node & {
  /** Audits changes between reports */
  auditsComparison: AuditsComparison;
  /** Categories changes between reports */
  categoriesComparison: CategoriesComparison;
  /** Git commits */
  commits: CommitComparison;
  /** Groups changes between reports */
  groupsComparison: GroupsComparison;
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
  /** Project */
  project: Project;
  /** Git repo */
  repository: Repository;
  /** Web link to reports comparison in portal */
  url: Scalars['URL']['output'];
};

/** Basic stats for a given report */
export type ReportStats = {
  _?: Maybe<Scalars['Boolean']['output']>;
  /** Audits' stats */
  audits: AuditsStats;
  /** Issues' stats */
  issues: IssuesStats;
  /** Plugins' stats */
  plugins: PluginsStats;
};

/** Statistical trend for analysis reports */
export type ReportsTrend = {
  _?: Maybe<Scalars['Boolean']['output']>;
  /** Trends for given audits */
  auditTrends: Array<AuditTrend>;
  /** Trends for given categories */
  categoryTrends: Array<CategoryTrend>;
};

/** Statistical trend for analysis reports */
export type ReportsTrendAuditTrendsArgs = {
  audits?: InputMaybe<Array<AuditRef>>;
  where?: InputMaybe<AuditTrendFilters>;
};

/** Statistical trend for analysis reports */
export type ReportsTrendCategoryTrendsArgs = {
  categories?: InputMaybe<Array<Scalars['Slug']['input']>>;
};

/** Remote Git repository */
export type Repository = {
  /** Repository contents (null if the repository is unauthorized) */
  contents?: Maybe<RepositoryContents>;
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
  /** Connected projects */
  projects: Array<Maybe<Project>>;
};

/** Remote Git repository contents */
export type RepositoryContents = {
  /** Branch */
  branch?: Maybe<Branch>;
  /** Remote branches */
  branches: Array<Branch>;
  /** Commit */
  commit?: Maybe<Commit>;
  /** Latest commits for given Git ref */
  commits?: Maybe<Array<Commit>>;
  /** Default branch */
  defaultBranch: Branch;
  /** File content */
  fileContent?: Maybe<Scalars['String']['output']>;
  /** Git tag */
  tag?: Maybe<Tag>;
  /** All Git tags in the repository */
  tags: Array<Tag>;
  /** Web URL */
  url: Scalars['String']['output'];
};

/** Remote Git repository contents */
export type RepositoryContentsBranchArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Remote Git repository contents */
export type RepositoryContentsBranchesArgs = {
  skipWithoutReport?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Remote Git repository contents */
export type RepositoryContentsCommitArgs = {
  ref?: InputMaybe<Scalars['String']['input']>;
};

/** Remote Git repository contents */
export type RepositoryContentsCommitsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

/** Remote Git repository contents */
export type RepositoryContentsFileContentArgs = {
  endLine?: InputMaybe<Scalars['Int']['input']>;
  path: Scalars['String']['input'];
  ref?: InputMaybe<Scalars['String']['input']>;
  startLine?: InputMaybe<Scalars['Int']['input']>;
};

/** Remote Git repository contents */
export type RepositoryContentsTagArgs = {
  name: Scalars['String']['input'];
};

/** Remote Git repository contents */
export type RepositoryContentsTagsArgs = {
  skipWithoutReport?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A role that's assigned to a user in an organization or its project */
export type RoleWithinOrganization = {
  /** Project slug if applicable, null if role applies to whole organization */
  project?: InputMaybe<Scalars['Slug']['input']>;
  /** Role */
  role: LocalRole;
};

/** Pre-defined API key permission set */
export enum Scope {
  /** read:api - read-only access to everything */
  ReadApi = 'ReadApi',
  /** read:reports - for category badges */
  ReadReports = 'ReadReports',
  /** write:projects - for creating projects */
  WriteProjects = 'WriteProjects',
  /** write:reports - for uploading to portal */
  WriteReports = 'WriteReports',
}

/** Sign-in method */
export type SignInMethod = {
  /** Unique ID (for caching) */
  id: Scalars['ID']['output'];
};

/** Type of sign-in method */
export enum SignInMethodVariant {
  /** Access based on allowed emails */
  Email = 'Email',
}

/** Reference to source code */
export type SourceCodeLocation = {
  /** Column on line where issue ends (columns numbered from 1) */
  endColumn?: Maybe<Scalars['Int']['output']>;
  /** Line in file where issue ends (lines numbered from 1) */
  endLine?: Maybe<Scalars['Int']['output']>;
  /** Source file (full path from repository root) */
  filePath: Scalars['String']['output'];
  /** Git repo */
  repository: Repository;
  /** Column on line where issue starts (columns numbered from 1) */
  startColumn?: Maybe<Scalars['Int']['output']>;
  /** Line in file where issue starts (lines numbered from 1) */
  startLine?: Maybe<Scalars['Int']['output']>;
  /** Web link to source file (with highlighted lines) in remote Git repo */
  webUrl: Scalars['String']['output'];
};

/** Reference to an element on a web page */
export type SourceUrlLocation = {
  /** Selector to locate the element */
  selector?: Maybe<Scalars['String']['output']>;
  /** Code snippet of the element */
  snippet?: Maybe<Scalars['String']['output']>;
  /** URL of the web page where the issue was found */
  url: Scalars['String']['output'];
};

/** Subject type for checking permissions */
export enum Subject {
  /** API key */
  ApiKey = 'ApiKey',
  /** Organization */
  Organization = 'Organization',
  /** Project */
  Project = 'Project',
  /** Report */
  Report = 'Report',
  /** Sign-in method */
  SignInMethod = 'SignInMethod',
  /** User */
  User = 'User',
}

/** Additional audit data in table format */
export type Table = Node & {
  /** Table body rows */
  body: Array<Array<TableCell>>;
  /** Table header row */
  header?: Maybe<Array<TableCell>>;
  /** Random ID */
  id: Scalars['ID']['output'];
  /** Display heading */
  title?: Maybe<Scalars['String']['output']>;
};

/** Table column alignment */
export enum TableAlignment {
  /** Aligned in the middle */
  Center = 'Center',
  /** Aligned to the left side */
  Left = 'Left',
  /** Aligned to the right side */
  Right = 'Right',
}

/** Cell content of audit details table */
export type TableCell = {
  /** Text alignment */
  alignment: TableAlignment;
  /** Display text */
  content: Scalars['String']['output'];
};

/** Individual table from reports comparison */
export type TableComparison = {
  /** Table from new report (unless status is Removed) */
  after?: Maybe<Table>;
  /** Table from old report (unless status is Added) */
  before?: Maybe<Table>;
  /** Comparison status */
  status: TableComparisonStatus;
};

/** Filters for tables from reports comparison */
export type TableComparisonFilters = {
  /** Only tables matching this status will be fetched */
  status?: InputMaybe<TableComparisonStatus>;
};

/** Status of table compared between reports */
export enum TableComparisonStatus {
  /** Table is present in new report, but not old report */
  Added = 'Added',
  /** Table body is changed */
  Changed = 'Changed',
  /** Table is present in old report, but not new report */
  Removed = 'Removed',
  /** Table body is unchanged */
  Unchanged = 'Unchanged',
}

/** Number of tables with given status */
export type TableStatusCount = {
  /** Number of tables */
  count: Scalars['Int']['output'];
  /** Status */
  status: TableComparisonStatus;
};

/** Full comparison of tables between reports */
export type TablesComparison = {
  /** Comparing table counts between reports */
  stats: TablesComparisonStats;
  /** Tables with given status */
  tables: Array<TableComparison>;
};

/** Full comparison of tables between reports */
export type TablesComparisonTablesArgs = {
  where?: InputMaybe<TableComparisonFilters>;
};

/** Basic stats for comparing tables between reports */
export type TablesComparisonStats = {
  /** Number of tables which are changed, unchanged, etc. */
  countsPerStatus: Array<TableStatusCount>;
  /** Difference between total counts */
  totalChange: Scalars['Int']['output'];
};

/** Git tag */
export type Tag = {
  /** Tag name */
  name: Scalars['String']['output'];
  /** SHA of the tagged commit */
  sha: Scalars['CommitSHA']['output'];
  /** Link to tag in remote Git repo */
  url: Scalars['String']['output'];
};

/** Additional audit data in tree format */
export type Tree = BasicTree | CoverageTree;

/** Individual tree from reports comparison */
export type TreeComparison = {
  /** Tree from new report (unless status is Removed) */
  after?: Maybe<Tree>;
  /** Tree from old report (unless status is Added) */
  before?: Maybe<Tree>;
  /** Comparison status */
  status: TreeComparisonStatus;
};

/** Filters for trees from reports comparison */
export type TreeComparisonFilters = {
  /** Only trees matching this status will be fetched */
  status?: InputMaybe<TreeComparisonStatus>;
};

/** Status of tree compared between reports */
export enum TreeComparisonStatus {
  /** Tree is present in new report, but not old report */
  Added = 'Added',
  /** Tree nodes are changed */
  Changed = 'Changed',
  /** Tree is present in old report, but not new report */
  Removed = 'Removed',
  /** Tree nodes are unchanged */
  Unchanged = 'Unchanged',
}

/** Number of trees with given status */
export type TreeStatusCount = {
  /** Number of trees */
  count: Scalars['Int']['output'];
  /** Status */
  status: TreeComparisonStatus;
};

/** Type of tree */
export enum TreeType {
  /** Generic */
  Basic = 'Basic',
  /** Coverage */
  Coverage = 'Coverage',
}

/** Full comparison of trees between reports */
export type TreesComparison = {
  /** Comparing tree counts between reports */
  stats: TreesComparisonStats;
  /** Trees with given status */
  trees: Array<TreeComparison>;
};

/** Full comparison of trees between reports */
export type TreesComparisonTreesArgs = {
  where?: InputMaybe<TreeComparisonFilters>;
};

/** Basic stats for comparing trees between reports */
export type TreesComparisonStats = {
  /** Number of trees which are changed, unchanged, etc. */
  countsPerStatus: Array<TreeStatusCount>;
  /** Difference between total counts */
  totalChange: Scalars['Int']['output'];
};

/** Line range in source file with missing coverage (optionally referring to a specific function/class/etc.) */
export type UncoveredLoc = {
  /** Column on line where issue ends (columns numbered from 1) */
  endColumn?: Maybe<Scalars['Int']['output']>;
  /** Line in file where issue ends (lines numbered from 1) */
  endLine?: Maybe<Scalars['Int']['output']>;
  /** Type of entity in code (function, class, etc.) */
  kind?: Maybe<Scalars['String']['output']>;
  /** Identifier of function, class, etc. */
  name?: Maybe<Scalars['String']['output']>;
  /** Git repo */
  repository: Repository;
  /** Column on line where issue starts (columns numbered from 1) */
  startColumn?: Maybe<Scalars['Int']['output']>;
  /** Line in file where issue starts (lines numbered from 1) */
  startLine: Scalars['Int']['output'];
  /** Web link to source file (with highlighted lines) in remote Git repo */
  webUrl: Scalars['String']['output'];
};

/** Portal user */
export type User = Node & {
  /** Organizations where user is blocked */
  blockedFromOrganizations: Array<Organization>;
  /** Projects where user is blocked */
  blockedFromProjects: Array<Project>;
  /** User email */
  email: Scalars['Email']['output'];
  /** User ID */
  id: Scalars['ID']['output'];
  /** When user last logged in */
  lastSignIn?: Maybe<Scalars['Date']['output']>;
  /** Roles assigned to user */
  roles: Array<UserRole>;
};

/** Portal user */
export type UserBlockedFromOrganizationsArgs = {
  organization?: InputMaybe<Scalars['Slug']['input']>;
};

/** Portal user */
export type UserBlockedFromProjectsArgs = {
  organization?: InputMaybe<Scalars['Slug']['input']>;
};

/** Portal user */
export type UserRolesArgs = {
  organization?: InputMaybe<Scalars['Slug']['input']>;
};

/** Role assigned to user */
export type UserRole = GlobalUserRole | OrganizationUserRole | ProjectUserRole;

/** Type of user roles */
export enum UserRoleType {
  /** All users with any roles */
  All = 'All',
  /** Users with global roles */
  Global = 'Global',
  /** Users with local roles */
  Local = 'Local',
}

/** Tokens created for signed-in user */
export type UserTokens = {
  /** Access token */
  accessToken: Scalars['String']['output'];
  /** Refresh token */
  refreshToken: Scalars['String']['output'];
};

export type SaveReportMutationVariables = Exact<{
  organization: Scalars['Slug']['input'];
  project: Scalars['Slug']['input'];
  commit: Scalars['CommitSHA']['input'];
  plugins: Array<PluginReport> | PluginReport;
  categories: Array<CategoryConfig> | CategoryConfig;
  packageName?: InputMaybe<Scalars['NpmPackageName']['input']>;
  packageVersion?: InputMaybe<Scalars['NpmPackageVersion']['input']>;
  commandStartDate?: InputMaybe<Scalars['Date']['input']>;
  commandDuration?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SaveReportMutation = { saveReport: { url: string } };

export type ReportComparisonUrlQueryVariables = Exact<{
  organization: Scalars['Slug']['input'];
  project: Scalars['Slug']['input'];
  before: Scalars['String']['input'];
  after: Scalars['String']['input'];
}>;

export type ReportComparisonUrlQuery = {
  project?: { reportComparison?: { url: string } | null } | null;
};

export type ReportByCommitQueryVariables = Exact<{
  organization: Scalars['Slug']['input'];
  project: Scalars['Slug']['input'];
  commit: Scalars['CommitSHA']['input'];
  withAuditDetails?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ReportByCommitQuery = {
  report?: {
    packageName?: string | null;
    packageVersion?: string | null;
    commandStartDate?: string | null;
    commandDuration?: number | null;
    commit: {
      sha: string;
      message: string;
      date?: string | null;
      author?: { name: string; email: string } | null;
    };
    categories: Array<{
      slug: string;
      title: string;
      description?: string | null;
      score: number;
      scoreTarget?: number | null;
      refs: Array<{
        weight: number;
        target:
          | { __typename: 'Audit'; slug: string; plugin: { slug: string } }
          | { __typename: 'Group'; slug: string; plugin: { slug: string } };
      }>;
    }>;
    plugins: Array<{
      slug: string;
      title: string;
      description?: string | null;
      docsUrl?: string | null;
      icon: MaterialIcon;
      packageName?: string | null;
      packageVersion?: string | null;
      runnerStartDate?: string | null;
      runnerDuration?: number | null;
      audits: {
        edges: Array<{
          node: {
            slug: string;
            title: string;
            description?: string | null;
            docsUrl?: string | null;
            score: number;
            value: number;
            formattedValue?: string | null;
            details?: {
              enabled: boolean;
              tables: Array<{
                title?: string | null;
                header?: Array<{
                  content: string;
                  alignment: TableAlignment;
                }> | null;
                body: Array<
                  Array<{ content: string; alignment: TableAlignment }>
                >;
              }>;
              trees: Array<
                | {
                    __typename: 'BasicTree';
                    title?: string | null;
                    root: {
                      name: string;
                      children?: Array<{
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          children?: Array<{
                                            name: string;
                                            children?: Array<{
                                              name: string;
                                              children?: Array<{
                                                name: string;
                                                children?: Array<{
                                                  name: string;
                                                  children?: Array<{
                                                    name: string;
                                                    children?: Array<{
                                                      name: string;
                                                      children?: Array<{
                                                        name: string;
                                                        children?: Array<{
                                                          name: string;
                                                          children?: Array<{
                                                            name: string;
                                                            customValues?: Array<{
                                                              key: string;
                                                              value: string;
                                                            }> | null;
                                                          }> | null;
                                                          customValues?: Array<{
                                                            key: string;
                                                            value: string;
                                                          }> | null;
                                                        }> | null;
                                                        customValues?: Array<{
                                                          key: string;
                                                          value: string;
                                                        }> | null;
                                                      }> | null;
                                                      customValues?: Array<{
                                                        key: string;
                                                        value: string;
                                                      }> | null;
                                                    }> | null;
                                                    customValues?: Array<{
                                                      key: string;
                                                      value: string;
                                                    }> | null;
                                                  }> | null;
                                                  customValues?: Array<{
                                                    key: string;
                                                    value: string;
                                                  }> | null;
                                                }> | null;
                                                customValues?: Array<{
                                                  key: string;
                                                  value: string;
                                                }> | null;
                                              }> | null;
                                              customValues?: Array<{
                                                key: string;
                                                value: string;
                                              }> | null;
                                            }> | null;
                                            customValues?: Array<{
                                              key: string;
                                              value: string;
                                            }> | null;
                                          }> | null;
                                          customValues?: Array<{
                                            key: string;
                                            value: string;
                                          }> | null;
                                        }> | null;
                                        customValues?: Array<{
                                          key: string;
                                          value: string;
                                        }> | null;
                                      }> | null;
                                      customValues?: Array<{
                                        key: string;
                                        value: string;
                                      }> | null;
                                    }> | null;
                                    customValues?: Array<{
                                      key: string;
                                      value: string;
                                    }> | null;
                                  }> | null;
                                  customValues?: Array<{
                                    key: string;
                                    value: string;
                                  }> | null;
                                }> | null;
                                customValues?: Array<{
                                  key: string;
                                  value: string;
                                }> | null;
                              }> | null;
                              customValues?: Array<{
                                key: string;
                                value: string;
                              }> | null;
                            }> | null;
                            customValues?: Array<{
                              key: string;
                              value: string;
                            }> | null;
                          }> | null;
                          customValues?: Array<{
                            key: string;
                            value: string;
                          }> | null;
                        }> | null;
                        customValues?: Array<{
                          key: string;
                          value: string;
                        }> | null;
                      }> | null;
                      customValues?: Array<{
                        key: string;
                        value: string;
                      }> | null;
                    };
                  }
                | {
                    __typename: 'CoverageTree';
                    title?: string | null;
                    root: {
                      name: string;
                      children?: Array<{
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          children?: Array<{
                                            name: string;
                                            children?: Array<{
                                              name: string;
                                              children?: Array<{
                                                name: string;
                                                children?: Array<{
                                                  name: string;
                                                  children?: Array<{
                                                    name: string;
                                                    children?: Array<{
                                                      name: string;
                                                      children?: Array<{
                                                        name: string;
                                                        children?: Array<{
                                                          name: string;
                                                          children?: Array<{
                                                            name: string;
                                                            values: {
                                                              coverage: number;
                                                              missing?: Array<{
                                                                kind?:
                                                                  | string
                                                                  | null;
                                                                name?:
                                                                  | string
                                                                  | null;
                                                                startLine: number;
                                                                startColumn?:
                                                                  | number
                                                                  | null;
                                                                endLine?:
                                                                  | number
                                                                  | null;
                                                                endColumn?:
                                                                  | number
                                                                  | null;
                                                              }> | null;
                                                            };
                                                          }> | null;
                                                          values: {
                                                            coverage: number;
                                                            missing?: Array<{
                                                              kind?:
                                                                | string
                                                                | null;
                                                              name?:
                                                                | string
                                                                | null;
                                                              startLine: number;
                                                              startColumn?:
                                                                | number
                                                                | null;
                                                              endLine?:
                                                                | number
                                                                | null;
                                                              endColumn?:
                                                                | number
                                                                | null;
                                                            }> | null;
                                                          };
                                                        }> | null;
                                                        values: {
                                                          coverage: number;
                                                          missing?: Array<{
                                                            kind?:
                                                              | string
                                                              | null;
                                                            name?:
                                                              | string
                                                              | null;
                                                            startLine: number;
                                                            startColumn?:
                                                              | number
                                                              | null;
                                                            endLine?:
                                                              | number
                                                              | null;
                                                            endColumn?:
                                                              | number
                                                              | null;
                                                          }> | null;
                                                        };
                                                      }> | null;
                                                      values: {
                                                        coverage: number;
                                                        missing?: Array<{
                                                          kind?: string | null;
                                                          name?: string | null;
                                                          startLine: number;
                                                          startColumn?:
                                                            | number
                                                            | null;
                                                          endLine?:
                                                            | number
                                                            | null;
                                                          endColumn?:
                                                            | number
                                                            | null;
                                                        }> | null;
                                                      };
                                                    }> | null;
                                                    values: {
                                                      coverage: number;
                                                      missing?: Array<{
                                                        kind?: string | null;
                                                        name?: string | null;
                                                        startLine: number;
                                                        startColumn?:
                                                          | number
                                                          | null;
                                                        endLine?: number | null;
                                                        endColumn?:
                                                          | number
                                                          | null;
                                                      }> | null;
                                                    };
                                                  }> | null;
                                                  values: {
                                                    coverage: number;
                                                    missing?: Array<{
                                                      kind?: string | null;
                                                      name?: string | null;
                                                      startLine: number;
                                                      startColumn?:
                                                        | number
                                                        | null;
                                                      endLine?: number | null;
                                                      endColumn?: number | null;
                                                    }> | null;
                                                  };
                                                }> | null;
                                                values: {
                                                  coverage: number;
                                                  missing?: Array<{
                                                    kind?: string | null;
                                                    name?: string | null;
                                                    startLine: number;
                                                    startColumn?: number | null;
                                                    endLine?: number | null;
                                                    endColumn?: number | null;
                                                  }> | null;
                                                };
                                              }> | null;
                                              values: {
                                                coverage: number;
                                                missing?: Array<{
                                                  kind?: string | null;
                                                  name?: string | null;
                                                  startLine: number;
                                                  startColumn?: number | null;
                                                  endLine?: number | null;
                                                  endColumn?: number | null;
                                                }> | null;
                                              };
                                            }> | null;
                                            values: {
                                              coverage: number;
                                              missing?: Array<{
                                                kind?: string | null;
                                                name?: string | null;
                                                startLine: number;
                                                startColumn?: number | null;
                                                endLine?: number | null;
                                                endColumn?: number | null;
                                              }> | null;
                                            };
                                          }> | null;
                                          values: {
                                            coverage: number;
                                            missing?: Array<{
                                              kind?: string | null;
                                              name?: string | null;
                                              startLine: number;
                                              startColumn?: number | null;
                                              endLine?: number | null;
                                              endColumn?: number | null;
                                            }> | null;
                                          };
                                        }> | null;
                                        values: {
                                          coverage: number;
                                          missing?: Array<{
                                            kind?: string | null;
                                            name?: string | null;
                                            startLine: number;
                                            startColumn?: number | null;
                                            endLine?: number | null;
                                            endColumn?: number | null;
                                          }> | null;
                                        };
                                      }> | null;
                                      values: {
                                        coverage: number;
                                        missing?: Array<{
                                          kind?: string | null;
                                          name?: string | null;
                                          startLine: number;
                                          startColumn?: number | null;
                                          endLine?: number | null;
                                          endColumn?: number | null;
                                        }> | null;
                                      };
                                    }> | null;
                                    values: {
                                      coverage: number;
                                      missing?: Array<{
                                        kind?: string | null;
                                        name?: string | null;
                                        startLine: number;
                                        startColumn?: number | null;
                                        endLine?: number | null;
                                        endColumn?: number | null;
                                      }> | null;
                                    };
                                  }> | null;
                                  values: {
                                    coverage: number;
                                    missing?: Array<{
                                      kind?: string | null;
                                      name?: string | null;
                                      startLine: number;
                                      startColumn?: number | null;
                                      endLine?: number | null;
                                      endColumn?: number | null;
                                    }> | null;
                                  };
                                }> | null;
                                values: {
                                  coverage: number;
                                  missing?: Array<{
                                    kind?: string | null;
                                    name?: string | null;
                                    startLine: number;
                                    startColumn?: number | null;
                                    endLine?: number | null;
                                    endColumn?: number | null;
                                  }> | null;
                                };
                              }> | null;
                              values: {
                                coverage: number;
                                missing?: Array<{
                                  kind?: string | null;
                                  name?: string | null;
                                  startLine: number;
                                  startColumn?: number | null;
                                  endLine?: number | null;
                                  endColumn?: number | null;
                                }> | null;
                              };
                            }> | null;
                            values: {
                              coverage: number;
                              missing?: Array<{
                                kind?: string | null;
                                name?: string | null;
                                startLine: number;
                                startColumn?: number | null;
                                endLine?: number | null;
                                endColumn?: number | null;
                              }> | null;
                            };
                          }> | null;
                          values: {
                            coverage: number;
                            missing?: Array<{
                              kind?: string | null;
                              name?: string | null;
                              startLine: number;
                              startColumn?: number | null;
                              endLine?: number | null;
                              endColumn?: number | null;
                            }> | null;
                          };
                        }> | null;
                        values: {
                          coverage: number;
                          missing?: Array<{
                            kind?: string | null;
                            name?: string | null;
                            startLine: number;
                            startColumn?: number | null;
                            endLine?: number | null;
                            endColumn?: number | null;
                          }> | null;
                        };
                      }> | null;
                      values: {
                        coverage: number;
                        missing?: Array<{
                          kind?: string | null;
                          name?: string | null;
                          startLine: number;
                          startColumn?: number | null;
                          endLine?: number | null;
                          endColumn?: number | null;
                        }> | null;
                      };
                    };
                  }
              >;
            } | null;
          };
        }>;
      };
      groups: Array<{
        slug: string;
        title: string;
        description?: string | null;
        score: number;
        refs: Array<{ weight: number; target: { slug: string } }>;
      }>;
    }>;
    issues?: {
      edges: Array<{
        node: {
          message: string;
          severity: IssueSeverity;
          audit: { slug: string; plugin: { slug: string } };
          source?:
            | {
                __typename: 'SourceCodeLocation';
                filePath: string;
                startLine?: number | null;
                startColumn?: number | null;
                endLine?: number | null;
                endColumn?: number | null;
              }
            | {
                __typename: 'SourceUrlLocation';
                url: string;
                snippet?: string | null;
                selector?: string | null;
              }
            | null;
        };
      }>;
    };
  } | null;
};

export type LatestReportQueryVariables = Exact<{
  organization: Scalars['Slug']['input'];
  project: Scalars['Slug']['input'];
  withAuditDetails?: InputMaybe<Scalars['Boolean']['input']>;
  maxCommits?: InputMaybe<Scalars['Int']['input']>;
}>;

export type LatestReportQuery = {
  project?: {
    latestReport?: {
      packageName?: string | null;
      packageVersion?: string | null;
      commandStartDate?: string | null;
      commandDuration?: number | null;
      commit: {
        sha: string;
        message: string;
        date?: string | null;
        author?: { name: string; email: string } | null;
      };
      categories: Array<{
        slug: string;
        title: string;
        description?: string | null;
        score: number;
        scoreTarget?: number | null;
        refs: Array<{
          weight: number;
          target:
            | { __typename: 'Audit'; slug: string; plugin: { slug: string } }
            | { __typename: 'Group'; slug: string; plugin: { slug: string } };
        }>;
      }>;
      plugins: Array<{
        slug: string;
        title: string;
        description?: string | null;
        docsUrl?: string | null;
        icon: MaterialIcon;
        packageName?: string | null;
        packageVersion?: string | null;
        runnerStartDate?: string | null;
        runnerDuration?: number | null;
        audits: {
          edges: Array<{
            node: {
              slug: string;
              title: string;
              description?: string | null;
              docsUrl?: string | null;
              score: number;
              value: number;
              formattedValue?: string | null;
              details?: {
                enabled: boolean;
                tables: Array<{
                  title?: string | null;
                  header?: Array<{
                    content: string;
                    alignment: TableAlignment;
                  }> | null;
                  body: Array<
                    Array<{ content: string; alignment: TableAlignment }>
                  >;
                }>;
                trees: Array<
                  | {
                      __typename: 'BasicTree';
                      title?: string | null;
                      root: {
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          children?: Array<{
                                            name: string;
                                            children?: Array<{
                                              name: string;
                                              children?: Array<{
                                                name: string;
                                                children?: Array<{
                                                  name: string;
                                                  children?: Array<{
                                                    name: string;
                                                    children?: Array<{
                                                      name: string;
                                                      children?: Array<{
                                                        name: string;
                                                        children?: Array<{
                                                          name: string;
                                                          children?: Array<{
                                                            name: string;
                                                            children?: Array<{
                                                              name: string;
                                                              customValues?: Array<{
                                                                key: string;
                                                                value: string;
                                                              }> | null;
                                                            }> | null;
                                                            customValues?: Array<{
                                                              key: string;
                                                              value: string;
                                                            }> | null;
                                                          }> | null;
                                                          customValues?: Array<{
                                                            key: string;
                                                            value: string;
                                                          }> | null;
                                                        }> | null;
                                                        customValues?: Array<{
                                                          key: string;
                                                          value: string;
                                                        }> | null;
                                                      }> | null;
                                                      customValues?: Array<{
                                                        key: string;
                                                        value: string;
                                                      }> | null;
                                                    }> | null;
                                                    customValues?: Array<{
                                                      key: string;
                                                      value: string;
                                                    }> | null;
                                                  }> | null;
                                                  customValues?: Array<{
                                                    key: string;
                                                    value: string;
                                                  }> | null;
                                                }> | null;
                                                customValues?: Array<{
                                                  key: string;
                                                  value: string;
                                                }> | null;
                                              }> | null;
                                              customValues?: Array<{
                                                key: string;
                                                value: string;
                                              }> | null;
                                            }> | null;
                                            customValues?: Array<{
                                              key: string;
                                              value: string;
                                            }> | null;
                                          }> | null;
                                          customValues?: Array<{
                                            key: string;
                                            value: string;
                                          }> | null;
                                        }> | null;
                                        customValues?: Array<{
                                          key: string;
                                          value: string;
                                        }> | null;
                                      }> | null;
                                      customValues?: Array<{
                                        key: string;
                                        value: string;
                                      }> | null;
                                    }> | null;
                                    customValues?: Array<{
                                      key: string;
                                      value: string;
                                    }> | null;
                                  }> | null;
                                  customValues?: Array<{
                                    key: string;
                                    value: string;
                                  }> | null;
                                }> | null;
                                customValues?: Array<{
                                  key: string;
                                  value: string;
                                }> | null;
                              }> | null;
                              customValues?: Array<{
                                key: string;
                                value: string;
                              }> | null;
                            }> | null;
                            customValues?: Array<{
                              key: string;
                              value: string;
                            }> | null;
                          }> | null;
                          customValues?: Array<{
                            key: string;
                            value: string;
                          }> | null;
                        }> | null;
                        customValues?: Array<{
                          key: string;
                          value: string;
                        }> | null;
                      };
                    }
                  | {
                      __typename: 'CoverageTree';
                      title?: string | null;
                      root: {
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          children?: Array<{
                                            name: string;
                                            children?: Array<{
                                              name: string;
                                              children?: Array<{
                                                name: string;
                                                children?: Array<{
                                                  name: string;
                                                  children?: Array<{
                                                    name: string;
                                                    children?: Array<{
                                                      name: string;
                                                      children?: Array<{
                                                        name: string;
                                                        children?: Array<{
                                                          name: string;
                                                          children?: Array<{
                                                            name: string;
                                                            children?: Array<{
                                                              name: string;
                                                              values: {
                                                                coverage: number;
                                                                missing?: Array<{
                                                                  kind?:
                                                                    | string
                                                                    | null;
                                                                  name?:
                                                                    | string
                                                                    | null;
                                                                  startLine: number;
                                                                  startColumn?:
                                                                    | number
                                                                    | null;
                                                                  endLine?:
                                                                    | number
                                                                    | null;
                                                                  endColumn?:
                                                                    | number
                                                                    | null;
                                                                }> | null;
                                                              };
                                                            }> | null;
                                                            values: {
                                                              coverage: number;
                                                              missing?: Array<{
                                                                kind?:
                                                                  | string
                                                                  | null;
                                                                name?:
                                                                  | string
                                                                  | null;
                                                                startLine: number;
                                                                startColumn?:
                                                                  | number
                                                                  | null;
                                                                endLine?:
                                                                  | number
                                                                  | null;
                                                                endColumn?:
                                                                  | number
                                                                  | null;
                                                              }> | null;
                                                            };
                                                          }> | null;
                                                          values: {
                                                            coverage: number;
                                                            missing?: Array<{
                                                              kind?:
                                                                | string
                                                                | null;
                                                              name?:
                                                                | string
                                                                | null;
                                                              startLine: number;
                                                              startColumn?:
                                                                | number
                                                                | null;
                                                              endLine?:
                                                                | number
                                                                | null;
                                                              endColumn?:
                                                                | number
                                                                | null;
                                                            }> | null;
                                                          };
                                                        }> | null;
                                                        values: {
                                                          coverage: number;
                                                          missing?: Array<{
                                                            kind?:
                                                              | string
                                                              | null;
                                                            name?:
                                                              | string
                                                              | null;
                                                            startLine: number;
                                                            startColumn?:
                                                              | number
                                                              | null;
                                                            endLine?:
                                                              | number
                                                              | null;
                                                            endColumn?:
                                                              | number
                                                              | null;
                                                          }> | null;
                                                        };
                                                      }> | null;
                                                      values: {
                                                        coverage: number;
                                                        missing?: Array<{
                                                          kind?: string | null;
                                                          name?: string | null;
                                                          startLine: number;
                                                          startColumn?:
                                                            | number
                                                            | null;
                                                          endLine?:
                                                            | number
                                                            | null;
                                                          endColumn?:
                                                            | number
                                                            | null;
                                                        }> | null;
                                                      };
                                                    }> | null;
                                                    values: {
                                                      coverage: number;
                                                      missing?: Array<{
                                                        kind?: string | null;
                                                        name?: string | null;
                                                        startLine: number;
                                                        startColumn?:
                                                          | number
                                                          | null;
                                                        endLine?: number | null;
                                                        endColumn?:
                                                          | number
                                                          | null;
                                                      }> | null;
                                                    };
                                                  }> | null;
                                                  values: {
                                                    coverage: number;
                                                    missing?: Array<{
                                                      kind?: string | null;
                                                      name?: string | null;
                                                      startLine: number;
                                                      startColumn?:
                                                        | number
                                                        | null;
                                                      endLine?: number | null;
                                                      endColumn?: number | null;
                                                    }> | null;
                                                  };
                                                }> | null;
                                                values: {
                                                  coverage: number;
                                                  missing?: Array<{
                                                    kind?: string | null;
                                                    name?: string | null;
                                                    startLine: number;
                                                    startColumn?: number | null;
                                                    endLine?: number | null;
                                                    endColumn?: number | null;
                                                  }> | null;
                                                };
                                              }> | null;
                                              values: {
                                                coverage: number;
                                                missing?: Array<{
                                                  kind?: string | null;
                                                  name?: string | null;
                                                  startLine: number;
                                                  startColumn?: number | null;
                                                  endLine?: number | null;
                                                  endColumn?: number | null;
                                                }> | null;
                                              };
                                            }> | null;
                                            values: {
                                              coverage: number;
                                              missing?: Array<{
                                                kind?: string | null;
                                                name?: string | null;
                                                startLine: number;
                                                startColumn?: number | null;
                                                endLine?: number | null;
                                                endColumn?: number | null;
                                              }> | null;
                                            };
                                          }> | null;
                                          values: {
                                            coverage: number;
                                            missing?: Array<{
                                              kind?: string | null;
                                              name?: string | null;
                                              startLine: number;
                                              startColumn?: number | null;
                                              endLine?: number | null;
                                              endColumn?: number | null;
                                            }> | null;
                                          };
                                        }> | null;
                                        values: {
                                          coverage: number;
                                          missing?: Array<{
                                            kind?: string | null;
                                            name?: string | null;
                                            startLine: number;
                                            startColumn?: number | null;
                                            endLine?: number | null;
                                            endColumn?: number | null;
                                          }> | null;
                                        };
                                      }> | null;
                                      values: {
                                        coverage: number;
                                        missing?: Array<{
                                          kind?: string | null;
                                          name?: string | null;
                                          startLine: number;
                                          startColumn?: number | null;
                                          endLine?: number | null;
                                          endColumn?: number | null;
                                        }> | null;
                                      };
                                    }> | null;
                                    values: {
                                      coverage: number;
                                      missing?: Array<{
                                        kind?: string | null;
                                        name?: string | null;
                                        startLine: number;
                                        startColumn?: number | null;
                                        endLine?: number | null;
                                        endColumn?: number | null;
                                      }> | null;
                                    };
                                  }> | null;
                                  values: {
                                    coverage: number;
                                    missing?: Array<{
                                      kind?: string | null;
                                      name?: string | null;
                                      startLine: number;
                                      startColumn?: number | null;
                                      endLine?: number | null;
                                      endColumn?: number | null;
                                    }> | null;
                                  };
                                }> | null;
                                values: {
                                  coverage: number;
                                  missing?: Array<{
                                    kind?: string | null;
                                    name?: string | null;
                                    startLine: number;
                                    startColumn?: number | null;
                                    endLine?: number | null;
                                    endColumn?: number | null;
                                  }> | null;
                                };
                              }> | null;
                              values: {
                                coverage: number;
                                missing?: Array<{
                                  kind?: string | null;
                                  name?: string | null;
                                  startLine: number;
                                  startColumn?: number | null;
                                  endLine?: number | null;
                                  endColumn?: number | null;
                                }> | null;
                              };
                            }> | null;
                            values: {
                              coverage: number;
                              missing?: Array<{
                                kind?: string | null;
                                name?: string | null;
                                startLine: number;
                                startColumn?: number | null;
                                endLine?: number | null;
                                endColumn?: number | null;
                              }> | null;
                            };
                          }> | null;
                          values: {
                            coverage: number;
                            missing?: Array<{
                              kind?: string | null;
                              name?: string | null;
                              startLine: number;
                              startColumn?: number | null;
                              endLine?: number | null;
                              endColumn?: number | null;
                            }> | null;
                          };
                        }> | null;
                        values: {
                          coverage: number;
                          missing?: Array<{
                            kind?: string | null;
                            name?: string | null;
                            startLine: number;
                            startColumn?: number | null;
                            endLine?: number | null;
                            endColumn?: number | null;
                          }> | null;
                        };
                      };
                    }
                >;
              } | null;
            };
          }>;
        };
        groups: Array<{
          slug: string;
          title: string;
          description?: string | null;
          score: number;
          refs: Array<{ weight: number; target: { slug: string } }>;
        }>;
      }>;
      issues?: {
        edges: Array<{
          node: {
            message: string;
            severity: IssueSeverity;
            audit: { slug: string; plugin: { slug: string } };
            source?:
              | {
                  __typename: 'SourceCodeLocation';
                  filePath: string;
                  startLine?: number | null;
                  startColumn?: number | null;
                  endLine?: number | null;
                  endColumn?: number | null;
                }
              | {
                  __typename: 'SourceUrlLocation';
                  url: string;
                  snippet?: string | null;
                  selector?: string | null;
                }
              | null;
          };
        }>;
      };
    } | null;
  } | null;
};

export type ProjectsQueryVariables = Exact<{
  organization?: InputMaybe<Scalars['Slug']['input']>;
  withLatestReport?: InputMaybe<Scalars['Boolean']['input']>;
  withAuditDetails?: InputMaybe<Scalars['Boolean']['input']>;
  maxCommits?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ProjectsQuery = {
  projects: Array<{
    slug: string;
    friendlyName?: string | null;
    organization: { slug: string; friendlyName?: string | null };
    repository:
      | {
          __typename: 'GitHubRepository';
          owner: string;
          repo: string;
          contents?: { url: string; defaultBranch: { name: string } } | null;
        }
      | {
          __typename: 'GitLabRepository';
          owner: string;
          repo: string;
          contents?: { url: string; defaultBranch: { name: string } } | null;
        };
    latestReport?: {
      packageName?: string | null;
      packageVersion?: string | null;
      commandStartDate?: string | null;
      commandDuration?: number | null;
      commit: {
        sha: string;
        message: string;
        date?: string | null;
        author?: { name: string; email: string } | null;
      };
      categories: Array<{
        slug: string;
        title: string;
        description?: string | null;
        score: number;
        scoreTarget?: number | null;
        refs: Array<{
          weight: number;
          target:
            | { __typename: 'Audit'; slug: string; plugin: { slug: string } }
            | { __typename: 'Group'; slug: string; plugin: { slug: string } };
        }>;
      }>;
      plugins: Array<{
        slug: string;
        title: string;
        description?: string | null;
        docsUrl?: string | null;
        icon: MaterialIcon;
        packageName?: string | null;
        packageVersion?: string | null;
        runnerStartDate?: string | null;
        runnerDuration?: number | null;
        audits: {
          edges: Array<{
            node: {
              slug: string;
              title: string;
              description?: string | null;
              docsUrl?: string | null;
              score: number;
              value: number;
              formattedValue?: string | null;
              details?: {
                enabled: boolean;
                tables: Array<{
                  title?: string | null;
                  header?: Array<{
                    content: string;
                    alignment: TableAlignment;
                  }> | null;
                  body: Array<
                    Array<{ content: string; alignment: TableAlignment }>
                  >;
                }>;
                trees: Array<
                  | {
                      __typename: 'BasicTree';
                      title?: string | null;
                      root: {
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          children?: Array<{
                                            name: string;
                                            children?: Array<{
                                              name: string;
                                              children?: Array<{
                                                name: string;
                                                children?: Array<{
                                                  name: string;
                                                  children?: Array<{
                                                    name: string;
                                                    children?: Array<{
                                                      name: string;
                                                      children?: Array<{
                                                        name: string;
                                                        children?: Array<{
                                                          name: string;
                                                          children?: Array<{
                                                            name: string;
                                                            children?: Array<{
                                                              name: string;
                                                              customValues?: Array<{
                                                                key: string;
                                                                value: string;
                                                              }> | null;
                                                            }> | null;
                                                            customValues?: Array<{
                                                              key: string;
                                                              value: string;
                                                            }> | null;
                                                          }> | null;
                                                          customValues?: Array<{
                                                            key: string;
                                                            value: string;
                                                          }> | null;
                                                        }> | null;
                                                        customValues?: Array<{
                                                          key: string;
                                                          value: string;
                                                        }> | null;
                                                      }> | null;
                                                      customValues?: Array<{
                                                        key: string;
                                                        value: string;
                                                      }> | null;
                                                    }> | null;
                                                    customValues?: Array<{
                                                      key: string;
                                                      value: string;
                                                    }> | null;
                                                  }> | null;
                                                  customValues?: Array<{
                                                    key: string;
                                                    value: string;
                                                  }> | null;
                                                }> | null;
                                                customValues?: Array<{
                                                  key: string;
                                                  value: string;
                                                }> | null;
                                              }> | null;
                                              customValues?: Array<{
                                                key: string;
                                                value: string;
                                              }> | null;
                                            }> | null;
                                            customValues?: Array<{
                                              key: string;
                                              value: string;
                                            }> | null;
                                          }> | null;
                                          customValues?: Array<{
                                            key: string;
                                            value: string;
                                          }> | null;
                                        }> | null;
                                        customValues?: Array<{
                                          key: string;
                                          value: string;
                                        }> | null;
                                      }> | null;
                                      customValues?: Array<{
                                        key: string;
                                        value: string;
                                      }> | null;
                                    }> | null;
                                    customValues?: Array<{
                                      key: string;
                                      value: string;
                                    }> | null;
                                  }> | null;
                                  customValues?: Array<{
                                    key: string;
                                    value: string;
                                  }> | null;
                                }> | null;
                                customValues?: Array<{
                                  key: string;
                                  value: string;
                                }> | null;
                              }> | null;
                              customValues?: Array<{
                                key: string;
                                value: string;
                              }> | null;
                            }> | null;
                            customValues?: Array<{
                              key: string;
                              value: string;
                            }> | null;
                          }> | null;
                          customValues?: Array<{
                            key: string;
                            value: string;
                          }> | null;
                        }> | null;
                        customValues?: Array<{
                          key: string;
                          value: string;
                        }> | null;
                      };
                    }
                  | {
                      __typename: 'CoverageTree';
                      title?: string | null;
                      root: {
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          children?: Array<{
                                            name: string;
                                            children?: Array<{
                                              name: string;
                                              children?: Array<{
                                                name: string;
                                                children?: Array<{
                                                  name: string;
                                                  children?: Array<{
                                                    name: string;
                                                    children?: Array<{
                                                      name: string;
                                                      children?: Array<{
                                                        name: string;
                                                        children?: Array<{
                                                          name: string;
                                                          children?: Array<{
                                                            name: string;
                                                            children?: Array<{
                                                              name: string;
                                                              values: {
                                                                coverage: number;
                                                                missing?: Array<{
                                                                  kind?:
                                                                    | string
                                                                    | null;
                                                                  name?:
                                                                    | string
                                                                    | null;
                                                                  startLine: number;
                                                                  startColumn?:
                                                                    | number
                                                                    | null;
                                                                  endLine?:
                                                                    | number
                                                                    | null;
                                                                  endColumn?:
                                                                    | number
                                                                    | null;
                                                                }> | null;
                                                              };
                                                            }> | null;
                                                            values: {
                                                              coverage: number;
                                                              missing?: Array<{
                                                                kind?:
                                                                  | string
                                                                  | null;
                                                                name?:
                                                                  | string
                                                                  | null;
                                                                startLine: number;
                                                                startColumn?:
                                                                  | number
                                                                  | null;
                                                                endLine?:
                                                                  | number
                                                                  | null;
                                                                endColumn?:
                                                                  | number
                                                                  | null;
                                                              }> | null;
                                                            };
                                                          }> | null;
                                                          values: {
                                                            coverage: number;
                                                            missing?: Array<{
                                                              kind?:
                                                                | string
                                                                | null;
                                                              name?:
                                                                | string
                                                                | null;
                                                              startLine: number;
                                                              startColumn?:
                                                                | number
                                                                | null;
                                                              endLine?:
                                                                | number
                                                                | null;
                                                              endColumn?:
                                                                | number
                                                                | null;
                                                            }> | null;
                                                          };
                                                        }> | null;
                                                        values: {
                                                          coverage: number;
                                                          missing?: Array<{
                                                            kind?:
                                                              | string
                                                              | null;
                                                            name?:
                                                              | string
                                                              | null;
                                                            startLine: number;
                                                            startColumn?:
                                                              | number
                                                              | null;
                                                            endLine?:
                                                              | number
                                                              | null;
                                                            endColumn?:
                                                              | number
                                                              | null;
                                                          }> | null;
                                                        };
                                                      }> | null;
                                                      values: {
                                                        coverage: number;
                                                        missing?: Array<{
                                                          kind?: string | null;
                                                          name?: string | null;
                                                          startLine: number;
                                                          startColumn?:
                                                            | number
                                                            | null;
                                                          endLine?:
                                                            | number
                                                            | null;
                                                          endColumn?:
                                                            | number
                                                            | null;
                                                        }> | null;
                                                      };
                                                    }> | null;
                                                    values: {
                                                      coverage: number;
                                                      missing?: Array<{
                                                        kind?: string | null;
                                                        name?: string | null;
                                                        startLine: number;
                                                        startColumn?:
                                                          | number
                                                          | null;
                                                        endLine?: number | null;
                                                        endColumn?:
                                                          | number
                                                          | null;
                                                      }> | null;
                                                    };
                                                  }> | null;
                                                  values: {
                                                    coverage: number;
                                                    missing?: Array<{
                                                      kind?: string | null;
                                                      name?: string | null;
                                                      startLine: number;
                                                      startColumn?:
                                                        | number
                                                        | null;
                                                      endLine?: number | null;
                                                      endColumn?: number | null;
                                                    }> | null;
                                                  };
                                                }> | null;
                                                values: {
                                                  coverage: number;
                                                  missing?: Array<{
                                                    kind?: string | null;
                                                    name?: string | null;
                                                    startLine: number;
                                                    startColumn?: number | null;
                                                    endLine?: number | null;
                                                    endColumn?: number | null;
                                                  }> | null;
                                                };
                                              }> | null;
                                              values: {
                                                coverage: number;
                                                missing?: Array<{
                                                  kind?: string | null;
                                                  name?: string | null;
                                                  startLine: number;
                                                  startColumn?: number | null;
                                                  endLine?: number | null;
                                                  endColumn?: number | null;
                                                }> | null;
                                              };
                                            }> | null;
                                            values: {
                                              coverage: number;
                                              missing?: Array<{
                                                kind?: string | null;
                                                name?: string | null;
                                                startLine: number;
                                                startColumn?: number | null;
                                                endLine?: number | null;
                                                endColumn?: number | null;
                                              }> | null;
                                            };
                                          }> | null;
                                          values: {
                                            coverage: number;
                                            missing?: Array<{
                                              kind?: string | null;
                                              name?: string | null;
                                              startLine: number;
                                              startColumn?: number | null;
                                              endLine?: number | null;
                                              endColumn?: number | null;
                                            }> | null;
                                          };
                                        }> | null;
                                        values: {
                                          coverage: number;
                                          missing?: Array<{
                                            kind?: string | null;
                                            name?: string | null;
                                            startLine: number;
                                            startColumn?: number | null;
                                            endLine?: number | null;
                                            endColumn?: number | null;
                                          }> | null;
                                        };
                                      }> | null;
                                      values: {
                                        coverage: number;
                                        missing?: Array<{
                                          kind?: string | null;
                                          name?: string | null;
                                          startLine: number;
                                          startColumn?: number | null;
                                          endLine?: number | null;
                                          endColumn?: number | null;
                                        }> | null;
                                      };
                                    }> | null;
                                    values: {
                                      coverage: number;
                                      missing?: Array<{
                                        kind?: string | null;
                                        name?: string | null;
                                        startLine: number;
                                        startColumn?: number | null;
                                        endLine?: number | null;
                                        endColumn?: number | null;
                                      }> | null;
                                    };
                                  }> | null;
                                  values: {
                                    coverage: number;
                                    missing?: Array<{
                                      kind?: string | null;
                                      name?: string | null;
                                      startLine: number;
                                      startColumn?: number | null;
                                      endLine?: number | null;
                                      endColumn?: number | null;
                                    }> | null;
                                  };
                                }> | null;
                                values: {
                                  coverage: number;
                                  missing?: Array<{
                                    kind?: string | null;
                                    name?: string | null;
                                    startLine: number;
                                    startColumn?: number | null;
                                    endLine?: number | null;
                                    endColumn?: number | null;
                                  }> | null;
                                };
                              }> | null;
                              values: {
                                coverage: number;
                                missing?: Array<{
                                  kind?: string | null;
                                  name?: string | null;
                                  startLine: number;
                                  startColumn?: number | null;
                                  endLine?: number | null;
                                  endColumn?: number | null;
                                }> | null;
                              };
                            }> | null;
                            values: {
                              coverage: number;
                              missing?: Array<{
                                kind?: string | null;
                                name?: string | null;
                                startLine: number;
                                startColumn?: number | null;
                                endLine?: number | null;
                                endColumn?: number | null;
                              }> | null;
                            };
                          }> | null;
                          values: {
                            coverage: number;
                            missing?: Array<{
                              kind?: string | null;
                              name?: string | null;
                              startLine: number;
                              startColumn?: number | null;
                              endLine?: number | null;
                              endColumn?: number | null;
                            }> | null;
                          };
                        }> | null;
                        values: {
                          coverage: number;
                          missing?: Array<{
                            kind?: string | null;
                            name?: string | null;
                            startLine: number;
                            startColumn?: number | null;
                            endLine?: number | null;
                            endColumn?: number | null;
                          }> | null;
                        };
                      };
                    }
                >;
              } | null;
            };
          }>;
        };
        groups: Array<{
          slug: string;
          title: string;
          description?: string | null;
          score: number;
          refs: Array<{ weight: number; target: { slug: string } }>;
        }>;
      }>;
      issues?: {
        edges: Array<{
          node: {
            message: string;
            severity: IssueSeverity;
            audit: { slug: string; plugin: { slug: string } };
            source?:
              | {
                  __typename: 'SourceCodeLocation';
                  filePath: string;
                  startLine?: number | null;
                  startColumn?: number | null;
                  endLine?: number | null;
                  endColumn?: number | null;
                }
              | {
                  __typename: 'SourceUrlLocation';
                  url: string;
                  snippet?: string | null;
                  selector?: string | null;
                }
              | null;
          };
        }>;
      };
    } | null;
  }>;
};

export type ProjectFragment = {
  slug: string;
  friendlyName?: string | null;
  organization: { slug: string; friendlyName?: string | null };
  repository:
    | {
        __typename: 'GitHubRepository';
        owner: string;
        repo: string;
        contents?: { url: string; defaultBranch: { name: string } } | null;
      }
    | {
        __typename: 'GitLabRepository';
        owner: string;
        repo: string;
        contents?: { url: string; defaultBranch: { name: string } } | null;
      };
  latestReport?: {
    packageName?: string | null;
    packageVersion?: string | null;
    commandStartDate?: string | null;
    commandDuration?: number | null;
    commit: {
      sha: string;
      message: string;
      date?: string | null;
      author?: { name: string; email: string } | null;
    };
    categories: Array<{
      slug: string;
      title: string;
      description?: string | null;
      score: number;
      scoreTarget?: number | null;
      refs: Array<{
        weight: number;
        target:
          | { __typename: 'Audit'; slug: string; plugin: { slug: string } }
          | { __typename: 'Group'; slug: string; plugin: { slug: string } };
      }>;
    }>;
    plugins: Array<{
      slug: string;
      title: string;
      description?: string | null;
      docsUrl?: string | null;
      icon: MaterialIcon;
      packageName?: string | null;
      packageVersion?: string | null;
      runnerStartDate?: string | null;
      runnerDuration?: number | null;
      audits: {
        edges: Array<{
          node: {
            slug: string;
            title: string;
            description?: string | null;
            docsUrl?: string | null;
            score: number;
            value: number;
            formattedValue?: string | null;
            details?: {
              enabled: boolean;
              tables: Array<{
                title?: string | null;
                header?: Array<{
                  content: string;
                  alignment: TableAlignment;
                }> | null;
                body: Array<
                  Array<{ content: string; alignment: TableAlignment }>
                >;
              }>;
              trees: Array<
                | {
                    __typename: 'BasicTree';
                    title?: string | null;
                    root: {
                      name: string;
                      children?: Array<{
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          children?: Array<{
                                            name: string;
                                            children?: Array<{
                                              name: string;
                                              children?: Array<{
                                                name: string;
                                                children?: Array<{
                                                  name: string;
                                                  children?: Array<{
                                                    name: string;
                                                    children?: Array<{
                                                      name: string;
                                                      children?: Array<{
                                                        name: string;
                                                        children?: Array<{
                                                          name: string;
                                                          children?: Array<{
                                                            name: string;
                                                            customValues?: Array<{
                                                              key: string;
                                                              value: string;
                                                            }> | null;
                                                          }> | null;
                                                          customValues?: Array<{
                                                            key: string;
                                                            value: string;
                                                          }> | null;
                                                        }> | null;
                                                        customValues?: Array<{
                                                          key: string;
                                                          value: string;
                                                        }> | null;
                                                      }> | null;
                                                      customValues?: Array<{
                                                        key: string;
                                                        value: string;
                                                      }> | null;
                                                    }> | null;
                                                    customValues?: Array<{
                                                      key: string;
                                                      value: string;
                                                    }> | null;
                                                  }> | null;
                                                  customValues?: Array<{
                                                    key: string;
                                                    value: string;
                                                  }> | null;
                                                }> | null;
                                                customValues?: Array<{
                                                  key: string;
                                                  value: string;
                                                }> | null;
                                              }> | null;
                                              customValues?: Array<{
                                                key: string;
                                                value: string;
                                              }> | null;
                                            }> | null;
                                            customValues?: Array<{
                                              key: string;
                                              value: string;
                                            }> | null;
                                          }> | null;
                                          customValues?: Array<{
                                            key: string;
                                            value: string;
                                          }> | null;
                                        }> | null;
                                        customValues?: Array<{
                                          key: string;
                                          value: string;
                                        }> | null;
                                      }> | null;
                                      customValues?: Array<{
                                        key: string;
                                        value: string;
                                      }> | null;
                                    }> | null;
                                    customValues?: Array<{
                                      key: string;
                                      value: string;
                                    }> | null;
                                  }> | null;
                                  customValues?: Array<{
                                    key: string;
                                    value: string;
                                  }> | null;
                                }> | null;
                                customValues?: Array<{
                                  key: string;
                                  value: string;
                                }> | null;
                              }> | null;
                              customValues?: Array<{
                                key: string;
                                value: string;
                              }> | null;
                            }> | null;
                            customValues?: Array<{
                              key: string;
                              value: string;
                            }> | null;
                          }> | null;
                          customValues?: Array<{
                            key: string;
                            value: string;
                          }> | null;
                        }> | null;
                        customValues?: Array<{
                          key: string;
                          value: string;
                        }> | null;
                      }> | null;
                      customValues?: Array<{
                        key: string;
                        value: string;
                      }> | null;
                    };
                  }
                | {
                    __typename: 'CoverageTree';
                    title?: string | null;
                    root: {
                      name: string;
                      children?: Array<{
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          children?: Array<{
                                            name: string;
                                            children?: Array<{
                                              name: string;
                                              children?: Array<{
                                                name: string;
                                                children?: Array<{
                                                  name: string;
                                                  children?: Array<{
                                                    name: string;
                                                    children?: Array<{
                                                      name: string;
                                                      children?: Array<{
                                                        name: string;
                                                        children?: Array<{
                                                          name: string;
                                                          children?: Array<{
                                                            name: string;
                                                            values: {
                                                              coverage: number;
                                                              missing?: Array<{
                                                                kind?:
                                                                  | string
                                                                  | null;
                                                                name?:
                                                                  | string
                                                                  | null;
                                                                startLine: number;
                                                                startColumn?:
                                                                  | number
                                                                  | null;
                                                                endLine?:
                                                                  | number
                                                                  | null;
                                                                endColumn?:
                                                                  | number
                                                                  | null;
                                                              }> | null;
                                                            };
                                                          }> | null;
                                                          values: {
                                                            coverage: number;
                                                            missing?: Array<{
                                                              kind?:
                                                                | string
                                                                | null;
                                                              name?:
                                                                | string
                                                                | null;
                                                              startLine: number;
                                                              startColumn?:
                                                                | number
                                                                | null;
                                                              endLine?:
                                                                | number
                                                                | null;
                                                              endColumn?:
                                                                | number
                                                                | null;
                                                            }> | null;
                                                          };
                                                        }> | null;
                                                        values: {
                                                          coverage: number;
                                                          missing?: Array<{
                                                            kind?:
                                                              | string
                                                              | null;
                                                            name?:
                                                              | string
                                                              | null;
                                                            startLine: number;
                                                            startColumn?:
                                                              | number
                                                              | null;
                                                            endLine?:
                                                              | number
                                                              | null;
                                                            endColumn?:
                                                              | number
                                                              | null;
                                                          }> | null;
                                                        };
                                                      }> | null;
                                                      values: {
                                                        coverage: number;
                                                        missing?: Array<{
                                                          kind?: string | null;
                                                          name?: string | null;
                                                          startLine: number;
                                                          startColumn?:
                                                            | number
                                                            | null;
                                                          endLine?:
                                                            | number
                                                            | null;
                                                          endColumn?:
                                                            | number
                                                            | null;
                                                        }> | null;
                                                      };
                                                    }> | null;
                                                    values: {
                                                      coverage: number;
                                                      missing?: Array<{
                                                        kind?: string | null;
                                                        name?: string | null;
                                                        startLine: number;
                                                        startColumn?:
                                                          | number
                                                          | null;
                                                        endLine?: number | null;
                                                        endColumn?:
                                                          | number
                                                          | null;
                                                      }> | null;
                                                    };
                                                  }> | null;
                                                  values: {
                                                    coverage: number;
                                                    missing?: Array<{
                                                      kind?: string | null;
                                                      name?: string | null;
                                                      startLine: number;
                                                      startColumn?:
                                                        | number
                                                        | null;
                                                      endLine?: number | null;
                                                      endColumn?: number | null;
                                                    }> | null;
                                                  };
                                                }> | null;
                                                values: {
                                                  coverage: number;
                                                  missing?: Array<{
                                                    kind?: string | null;
                                                    name?: string | null;
                                                    startLine: number;
                                                    startColumn?: number | null;
                                                    endLine?: number | null;
                                                    endColumn?: number | null;
                                                  }> | null;
                                                };
                                              }> | null;
                                              values: {
                                                coverage: number;
                                                missing?: Array<{
                                                  kind?: string | null;
                                                  name?: string | null;
                                                  startLine: number;
                                                  startColumn?: number | null;
                                                  endLine?: number | null;
                                                  endColumn?: number | null;
                                                }> | null;
                                              };
                                            }> | null;
                                            values: {
                                              coverage: number;
                                              missing?: Array<{
                                                kind?: string | null;
                                                name?: string | null;
                                                startLine: number;
                                                startColumn?: number | null;
                                                endLine?: number | null;
                                                endColumn?: number | null;
                                              }> | null;
                                            };
                                          }> | null;
                                          values: {
                                            coverage: number;
                                            missing?: Array<{
                                              kind?: string | null;
                                              name?: string | null;
                                              startLine: number;
                                              startColumn?: number | null;
                                              endLine?: number | null;
                                              endColumn?: number | null;
                                            }> | null;
                                          };
                                        }> | null;
                                        values: {
                                          coverage: number;
                                          missing?: Array<{
                                            kind?: string | null;
                                            name?: string | null;
                                            startLine: number;
                                            startColumn?: number | null;
                                            endLine?: number | null;
                                            endColumn?: number | null;
                                          }> | null;
                                        };
                                      }> | null;
                                      values: {
                                        coverage: number;
                                        missing?: Array<{
                                          kind?: string | null;
                                          name?: string | null;
                                          startLine: number;
                                          startColumn?: number | null;
                                          endLine?: number | null;
                                          endColumn?: number | null;
                                        }> | null;
                                      };
                                    }> | null;
                                    values: {
                                      coverage: number;
                                      missing?: Array<{
                                        kind?: string | null;
                                        name?: string | null;
                                        startLine: number;
                                        startColumn?: number | null;
                                        endLine?: number | null;
                                        endColumn?: number | null;
                                      }> | null;
                                    };
                                  }> | null;
                                  values: {
                                    coverage: number;
                                    missing?: Array<{
                                      kind?: string | null;
                                      name?: string | null;
                                      startLine: number;
                                      startColumn?: number | null;
                                      endLine?: number | null;
                                      endColumn?: number | null;
                                    }> | null;
                                  };
                                }> | null;
                                values: {
                                  coverage: number;
                                  missing?: Array<{
                                    kind?: string | null;
                                    name?: string | null;
                                    startLine: number;
                                    startColumn?: number | null;
                                    endLine?: number | null;
                                    endColumn?: number | null;
                                  }> | null;
                                };
                              }> | null;
                              values: {
                                coverage: number;
                                missing?: Array<{
                                  kind?: string | null;
                                  name?: string | null;
                                  startLine: number;
                                  startColumn?: number | null;
                                  endLine?: number | null;
                                  endColumn?: number | null;
                                }> | null;
                              };
                            }> | null;
                            values: {
                              coverage: number;
                              missing?: Array<{
                                kind?: string | null;
                                name?: string | null;
                                startLine: number;
                                startColumn?: number | null;
                                endLine?: number | null;
                                endColumn?: number | null;
                              }> | null;
                            };
                          }> | null;
                          values: {
                            coverage: number;
                            missing?: Array<{
                              kind?: string | null;
                              name?: string | null;
                              startLine: number;
                              startColumn?: number | null;
                              endLine?: number | null;
                              endColumn?: number | null;
                            }> | null;
                          };
                        }> | null;
                        values: {
                          coverage: number;
                          missing?: Array<{
                            kind?: string | null;
                            name?: string | null;
                            startLine: number;
                            startColumn?: number | null;
                            endLine?: number | null;
                            endColumn?: number | null;
                          }> | null;
                        };
                      }> | null;
                      values: {
                        coverage: number;
                        missing?: Array<{
                          kind?: string | null;
                          name?: string | null;
                          startLine: number;
                          startColumn?: number | null;
                          endLine?: number | null;
                          endColumn?: number | null;
                        }> | null;
                      };
                    };
                  }
              >;
            } | null;
          };
        }>;
      };
      groups: Array<{
        slug: string;
        title: string;
        description?: string | null;
        score: number;
        refs: Array<{ weight: number; target: { slug: string } }>;
      }>;
    }>;
    issues?: {
      edges: Array<{
        node: {
          message: string;
          severity: IssueSeverity;
          audit: { slug: string; plugin: { slug: string } };
          source?:
            | {
                __typename: 'SourceCodeLocation';
                filePath: string;
                startLine?: number | null;
                startColumn?: number | null;
                endLine?: number | null;
                endColumn?: number | null;
              }
            | {
                __typename: 'SourceUrlLocation';
                url: string;
                snippet?: string | null;
                selector?: string | null;
              }
            | null;
        };
      }>;
    };
  } | null;
};

type Repository_GitHubRepository_Fragment = {
  __typename: 'GitHubRepository';
  owner: string;
  repo: string;
  contents?: { url: string; defaultBranch: { name: string } } | null;
};

type Repository_GitLabRepository_Fragment = {
  __typename: 'GitLabRepository';
  owner: string;
  repo: string;
  contents?: { url: string; defaultBranch: { name: string } } | null;
};

export type RepositoryFragment =
  | Repository_GitHubRepository_Fragment
  | Repository_GitLabRepository_Fragment;

export type ReportUrlFragment = { url: string };

export type ReportComparisonUrlFragment = { url: string };

export type ReportFragment = {
  packageName?: string | null;
  packageVersion?: string | null;
  commandStartDate?: string | null;
  commandDuration?: number | null;
  commit: {
    sha: string;
    message: string;
    date?: string | null;
    author?: { name: string; email: string } | null;
  };
  categories: Array<{
    slug: string;
    title: string;
    description?: string | null;
    score: number;
    scoreTarget?: number | null;
    refs: Array<{
      weight: number;
      target:
        | { __typename: 'Audit'; slug: string; plugin: { slug: string } }
        | { __typename: 'Group'; slug: string; plugin: { slug: string } };
    }>;
  }>;
  plugins: Array<{
    slug: string;
    title: string;
    description?: string | null;
    docsUrl?: string | null;
    icon: MaterialIcon;
    packageName?: string | null;
    packageVersion?: string | null;
    runnerStartDate?: string | null;
    runnerDuration?: number | null;
    audits: {
      edges: Array<{
        node: {
          slug: string;
          title: string;
          description?: string | null;
          docsUrl?: string | null;
          score: number;
          value: number;
          formattedValue?: string | null;
          details?: {
            enabled: boolean;
            tables: Array<{
              title?: string | null;
              header?: Array<{
                content: string;
                alignment: TableAlignment;
              }> | null;
              body: Array<
                Array<{ content: string; alignment: TableAlignment }>
              >;
            }>;
            trees: Array<
              | {
                  __typename: 'BasicTree';
                  title?: string | null;
                  root: {
                    name: string;
                    children?: Array<{
                      name: string;
                      children?: Array<{
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          children?: Array<{
                                            name: string;
                                            children?: Array<{
                                              name: string;
                                              children?: Array<{
                                                name: string;
                                                children?: Array<{
                                                  name: string;
                                                  children?: Array<{
                                                    name: string;
                                                    children?: Array<{
                                                      name: string;
                                                      children?: Array<{
                                                        name: string;
                                                        children?: Array<{
                                                          name: string;
                                                          customValues?: Array<{
                                                            key: string;
                                                            value: string;
                                                          }> | null;
                                                        }> | null;
                                                        customValues?: Array<{
                                                          key: string;
                                                          value: string;
                                                        }> | null;
                                                      }> | null;
                                                      customValues?: Array<{
                                                        key: string;
                                                        value: string;
                                                      }> | null;
                                                    }> | null;
                                                    customValues?: Array<{
                                                      key: string;
                                                      value: string;
                                                    }> | null;
                                                  }> | null;
                                                  customValues?: Array<{
                                                    key: string;
                                                    value: string;
                                                  }> | null;
                                                }> | null;
                                                customValues?: Array<{
                                                  key: string;
                                                  value: string;
                                                }> | null;
                                              }> | null;
                                              customValues?: Array<{
                                                key: string;
                                                value: string;
                                              }> | null;
                                            }> | null;
                                            customValues?: Array<{
                                              key: string;
                                              value: string;
                                            }> | null;
                                          }> | null;
                                          customValues?: Array<{
                                            key: string;
                                            value: string;
                                          }> | null;
                                        }> | null;
                                        customValues?: Array<{
                                          key: string;
                                          value: string;
                                        }> | null;
                                      }> | null;
                                      customValues?: Array<{
                                        key: string;
                                        value: string;
                                      }> | null;
                                    }> | null;
                                    customValues?: Array<{
                                      key: string;
                                      value: string;
                                    }> | null;
                                  }> | null;
                                  customValues?: Array<{
                                    key: string;
                                    value: string;
                                  }> | null;
                                }> | null;
                                customValues?: Array<{
                                  key: string;
                                  value: string;
                                }> | null;
                              }> | null;
                              customValues?: Array<{
                                key: string;
                                value: string;
                              }> | null;
                            }> | null;
                            customValues?: Array<{
                              key: string;
                              value: string;
                            }> | null;
                          }> | null;
                          customValues?: Array<{
                            key: string;
                            value: string;
                          }> | null;
                        }> | null;
                        customValues?: Array<{
                          key: string;
                          value: string;
                        }> | null;
                      }> | null;
                      customValues?: Array<{
                        key: string;
                        value: string;
                      }> | null;
                    }> | null;
                    customValues?: Array<{ key: string; value: string }> | null;
                  };
                }
              | {
                  __typename: 'CoverageTree';
                  title?: string | null;
                  root: {
                    name: string;
                    children?: Array<{
                      name: string;
                      children?: Array<{
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          children?: Array<{
                                            name: string;
                                            children?: Array<{
                                              name: string;
                                              children?: Array<{
                                                name: string;
                                                children?: Array<{
                                                  name: string;
                                                  children?: Array<{
                                                    name: string;
                                                    children?: Array<{
                                                      name: string;
                                                      children?: Array<{
                                                        name: string;
                                                        children?: Array<{
                                                          name: string;
                                                          values: {
                                                            coverage: number;
                                                            missing?: Array<{
                                                              kind?:
                                                                | string
                                                                | null;
                                                              name?:
                                                                | string
                                                                | null;
                                                              startLine: number;
                                                              startColumn?:
                                                                | number
                                                                | null;
                                                              endLine?:
                                                                | number
                                                                | null;
                                                              endColumn?:
                                                                | number
                                                                | null;
                                                            }> | null;
                                                          };
                                                        }> | null;
                                                        values: {
                                                          coverage: number;
                                                          missing?: Array<{
                                                            kind?:
                                                              | string
                                                              | null;
                                                            name?:
                                                              | string
                                                              | null;
                                                            startLine: number;
                                                            startColumn?:
                                                              | number
                                                              | null;
                                                            endLine?:
                                                              | number
                                                              | null;
                                                            endColumn?:
                                                              | number
                                                              | null;
                                                          }> | null;
                                                        };
                                                      }> | null;
                                                      values: {
                                                        coverage: number;
                                                        missing?: Array<{
                                                          kind?: string | null;
                                                          name?: string | null;
                                                          startLine: number;
                                                          startColumn?:
                                                            | number
                                                            | null;
                                                          endLine?:
                                                            | number
                                                            | null;
                                                          endColumn?:
                                                            | number
                                                            | null;
                                                        }> | null;
                                                      };
                                                    }> | null;
                                                    values: {
                                                      coverage: number;
                                                      missing?: Array<{
                                                        kind?: string | null;
                                                        name?: string | null;
                                                        startLine: number;
                                                        startColumn?:
                                                          | number
                                                          | null;
                                                        endLine?: number | null;
                                                        endColumn?:
                                                          | number
                                                          | null;
                                                      }> | null;
                                                    };
                                                  }> | null;
                                                  values: {
                                                    coverage: number;
                                                    missing?: Array<{
                                                      kind?: string | null;
                                                      name?: string | null;
                                                      startLine: number;
                                                      startColumn?:
                                                        | number
                                                        | null;
                                                      endLine?: number | null;
                                                      endColumn?: number | null;
                                                    }> | null;
                                                  };
                                                }> | null;
                                                values: {
                                                  coverage: number;
                                                  missing?: Array<{
                                                    kind?: string | null;
                                                    name?: string | null;
                                                    startLine: number;
                                                    startColumn?: number | null;
                                                    endLine?: number | null;
                                                    endColumn?: number | null;
                                                  }> | null;
                                                };
                                              }> | null;
                                              values: {
                                                coverage: number;
                                                missing?: Array<{
                                                  kind?: string | null;
                                                  name?: string | null;
                                                  startLine: number;
                                                  startColumn?: number | null;
                                                  endLine?: number | null;
                                                  endColumn?: number | null;
                                                }> | null;
                                              };
                                            }> | null;
                                            values: {
                                              coverage: number;
                                              missing?: Array<{
                                                kind?: string | null;
                                                name?: string | null;
                                                startLine: number;
                                                startColumn?: number | null;
                                                endLine?: number | null;
                                                endColumn?: number | null;
                                              }> | null;
                                            };
                                          }> | null;
                                          values: {
                                            coverage: number;
                                            missing?: Array<{
                                              kind?: string | null;
                                              name?: string | null;
                                              startLine: number;
                                              startColumn?: number | null;
                                              endLine?: number | null;
                                              endColumn?: number | null;
                                            }> | null;
                                          };
                                        }> | null;
                                        values: {
                                          coverage: number;
                                          missing?: Array<{
                                            kind?: string | null;
                                            name?: string | null;
                                            startLine: number;
                                            startColumn?: number | null;
                                            endLine?: number | null;
                                            endColumn?: number | null;
                                          }> | null;
                                        };
                                      }> | null;
                                      values: {
                                        coverage: number;
                                        missing?: Array<{
                                          kind?: string | null;
                                          name?: string | null;
                                          startLine: number;
                                          startColumn?: number | null;
                                          endLine?: number | null;
                                          endColumn?: number | null;
                                        }> | null;
                                      };
                                    }> | null;
                                    values: {
                                      coverage: number;
                                      missing?: Array<{
                                        kind?: string | null;
                                        name?: string | null;
                                        startLine: number;
                                        startColumn?: number | null;
                                        endLine?: number | null;
                                        endColumn?: number | null;
                                      }> | null;
                                    };
                                  }> | null;
                                  values: {
                                    coverage: number;
                                    missing?: Array<{
                                      kind?: string | null;
                                      name?: string | null;
                                      startLine: number;
                                      startColumn?: number | null;
                                      endLine?: number | null;
                                      endColumn?: number | null;
                                    }> | null;
                                  };
                                }> | null;
                                values: {
                                  coverage: number;
                                  missing?: Array<{
                                    kind?: string | null;
                                    name?: string | null;
                                    startLine: number;
                                    startColumn?: number | null;
                                    endLine?: number | null;
                                    endColumn?: number | null;
                                  }> | null;
                                };
                              }> | null;
                              values: {
                                coverage: number;
                                missing?: Array<{
                                  kind?: string | null;
                                  name?: string | null;
                                  startLine: number;
                                  startColumn?: number | null;
                                  endLine?: number | null;
                                  endColumn?: number | null;
                                }> | null;
                              };
                            }> | null;
                            values: {
                              coverage: number;
                              missing?: Array<{
                                kind?: string | null;
                                name?: string | null;
                                startLine: number;
                                startColumn?: number | null;
                                endLine?: number | null;
                                endColumn?: number | null;
                              }> | null;
                            };
                          }> | null;
                          values: {
                            coverage: number;
                            missing?: Array<{
                              kind?: string | null;
                              name?: string | null;
                              startLine: number;
                              startColumn?: number | null;
                              endLine?: number | null;
                              endColumn?: number | null;
                            }> | null;
                          };
                        }> | null;
                        values: {
                          coverage: number;
                          missing?: Array<{
                            kind?: string | null;
                            name?: string | null;
                            startLine: number;
                            startColumn?: number | null;
                            endLine?: number | null;
                            endColumn?: number | null;
                          }> | null;
                        };
                      }> | null;
                      values: {
                        coverage: number;
                        missing?: Array<{
                          kind?: string | null;
                          name?: string | null;
                          startLine: number;
                          startColumn?: number | null;
                          endLine?: number | null;
                          endColumn?: number | null;
                        }> | null;
                      };
                    }> | null;
                    values: {
                      coverage: number;
                      missing?: Array<{
                        kind?: string | null;
                        name?: string | null;
                        startLine: number;
                        startColumn?: number | null;
                        endLine?: number | null;
                        endColumn?: number | null;
                      }> | null;
                    };
                  };
                }
            >;
          } | null;
        };
      }>;
    };
    groups: Array<{
      slug: string;
      title: string;
      description?: string | null;
      score: number;
      refs: Array<{ weight: number; target: { slug: string } }>;
    }>;
  }>;
  issues?: {
    edges: Array<{
      node: {
        message: string;
        severity: IssueSeverity;
        audit: { slug: string; plugin: { slug: string } };
        source?:
          | {
              __typename: 'SourceCodeLocation';
              filePath: string;
              startLine?: number | null;
              startColumn?: number | null;
              endLine?: number | null;
              endColumn?: number | null;
            }
          | {
              __typename: 'SourceUrlLocation';
              url: string;
              snippet?: string | null;
              selector?: string | null;
            }
          | null;
      };
    }>;
  };
};

export type CommitFragment = {
  sha: string;
  message: string;
  date?: string | null;
  author?: { name: string; email: string } | null;
};

export type CategoryFragment = {
  slug: string;
  title: string;
  description?: string | null;
  score: number;
  scoreTarget?: number | null;
  refs: Array<{
    weight: number;
    target:
      | { __typename: 'Audit'; slug: string; plugin: { slug: string } }
      | { __typename: 'Group'; slug: string; plugin: { slug: string } };
  }>;
};

export type AuditFragment = {
  slug: string;
  title: string;
  description?: string | null;
  docsUrl?: string | null;
  score: number;
  value: number;
  formattedValue?: string | null;
  details?: {
    enabled: boolean;
    tables: Array<{
      title?: string | null;
      header?: Array<{ content: string; alignment: TableAlignment }> | null;
      body: Array<Array<{ content: string; alignment: TableAlignment }>>;
    }>;
    trees: Array<
      | {
          __typename: 'BasicTree';
          title?: string | null;
          root: {
            name: string;
            children?: Array<{
              name: string;
              children?: Array<{
                name: string;
                children?: Array<{
                  name: string;
                  children?: Array<{
                    name: string;
                    children?: Array<{
                      name: string;
                      children?: Array<{
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          children?: Array<{
                                            name: string;
                                            children?: Array<{
                                              name: string;
                                              children?: Array<{
                                                name: string;
                                                children?: Array<{
                                                  name: string;
                                                  customValues?: Array<{
                                                    key: string;
                                                    value: string;
                                                  }> | null;
                                                }> | null;
                                                customValues?: Array<{
                                                  key: string;
                                                  value: string;
                                                }> | null;
                                              }> | null;
                                              customValues?: Array<{
                                                key: string;
                                                value: string;
                                              }> | null;
                                            }> | null;
                                            customValues?: Array<{
                                              key: string;
                                              value: string;
                                            }> | null;
                                          }> | null;
                                          customValues?: Array<{
                                            key: string;
                                            value: string;
                                          }> | null;
                                        }> | null;
                                        customValues?: Array<{
                                          key: string;
                                          value: string;
                                        }> | null;
                                      }> | null;
                                      customValues?: Array<{
                                        key: string;
                                        value: string;
                                      }> | null;
                                    }> | null;
                                    customValues?: Array<{
                                      key: string;
                                      value: string;
                                    }> | null;
                                  }> | null;
                                  customValues?: Array<{
                                    key: string;
                                    value: string;
                                  }> | null;
                                }> | null;
                                customValues?: Array<{
                                  key: string;
                                  value: string;
                                }> | null;
                              }> | null;
                              customValues?: Array<{
                                key: string;
                                value: string;
                              }> | null;
                            }> | null;
                            customValues?: Array<{
                              key: string;
                              value: string;
                            }> | null;
                          }> | null;
                          customValues?: Array<{
                            key: string;
                            value: string;
                          }> | null;
                        }> | null;
                        customValues?: Array<{
                          key: string;
                          value: string;
                        }> | null;
                      }> | null;
                      customValues?: Array<{
                        key: string;
                        value: string;
                      }> | null;
                    }> | null;
                    customValues?: Array<{ key: string; value: string }> | null;
                  }> | null;
                  customValues?: Array<{ key: string; value: string }> | null;
                }> | null;
                customValues?: Array<{ key: string; value: string }> | null;
              }> | null;
              customValues?: Array<{ key: string; value: string }> | null;
            }> | null;
            customValues?: Array<{ key: string; value: string }> | null;
          };
        }
      | {
          __typename: 'CoverageTree';
          title?: string | null;
          root: {
            name: string;
            children?: Array<{
              name: string;
              children?: Array<{
                name: string;
                children?: Array<{
                  name: string;
                  children?: Array<{
                    name: string;
                    children?: Array<{
                      name: string;
                      children?: Array<{
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          children?: Array<{
                                            name: string;
                                            children?: Array<{
                                              name: string;
                                              children?: Array<{
                                                name: string;
                                                children?: Array<{
                                                  name: string;
                                                  values: {
                                                    coverage: number;
                                                    missing?: Array<{
                                                      kind?: string | null;
                                                      name?: string | null;
                                                      startLine: number;
                                                      startColumn?:
                                                        | number
                                                        | null;
                                                      endLine?: number | null;
                                                      endColumn?: number | null;
                                                    }> | null;
                                                  };
                                                }> | null;
                                                values: {
                                                  coverage: number;
                                                  missing?: Array<{
                                                    kind?: string | null;
                                                    name?: string | null;
                                                    startLine: number;
                                                    startColumn?: number | null;
                                                    endLine?: number | null;
                                                    endColumn?: number | null;
                                                  }> | null;
                                                };
                                              }> | null;
                                              values: {
                                                coverage: number;
                                                missing?: Array<{
                                                  kind?: string | null;
                                                  name?: string | null;
                                                  startLine: number;
                                                  startColumn?: number | null;
                                                  endLine?: number | null;
                                                  endColumn?: number | null;
                                                }> | null;
                                              };
                                            }> | null;
                                            values: {
                                              coverage: number;
                                              missing?: Array<{
                                                kind?: string | null;
                                                name?: string | null;
                                                startLine: number;
                                                startColumn?: number | null;
                                                endLine?: number | null;
                                                endColumn?: number | null;
                                              }> | null;
                                            };
                                          }> | null;
                                          values: {
                                            coverage: number;
                                            missing?: Array<{
                                              kind?: string | null;
                                              name?: string | null;
                                              startLine: number;
                                              startColumn?: number | null;
                                              endLine?: number | null;
                                              endColumn?: number | null;
                                            }> | null;
                                          };
                                        }> | null;
                                        values: {
                                          coverage: number;
                                          missing?: Array<{
                                            kind?: string | null;
                                            name?: string | null;
                                            startLine: number;
                                            startColumn?: number | null;
                                            endLine?: number | null;
                                            endColumn?: number | null;
                                          }> | null;
                                        };
                                      }> | null;
                                      values: {
                                        coverage: number;
                                        missing?: Array<{
                                          kind?: string | null;
                                          name?: string | null;
                                          startLine: number;
                                          startColumn?: number | null;
                                          endLine?: number | null;
                                          endColumn?: number | null;
                                        }> | null;
                                      };
                                    }> | null;
                                    values: {
                                      coverage: number;
                                      missing?: Array<{
                                        kind?: string | null;
                                        name?: string | null;
                                        startLine: number;
                                        startColumn?: number | null;
                                        endLine?: number | null;
                                        endColumn?: number | null;
                                      }> | null;
                                    };
                                  }> | null;
                                  values: {
                                    coverage: number;
                                    missing?: Array<{
                                      kind?: string | null;
                                      name?: string | null;
                                      startLine: number;
                                      startColumn?: number | null;
                                      endLine?: number | null;
                                      endColumn?: number | null;
                                    }> | null;
                                  };
                                }> | null;
                                values: {
                                  coverage: number;
                                  missing?: Array<{
                                    kind?: string | null;
                                    name?: string | null;
                                    startLine: number;
                                    startColumn?: number | null;
                                    endLine?: number | null;
                                    endColumn?: number | null;
                                  }> | null;
                                };
                              }> | null;
                              values: {
                                coverage: number;
                                missing?: Array<{
                                  kind?: string | null;
                                  name?: string | null;
                                  startLine: number;
                                  startColumn?: number | null;
                                  endLine?: number | null;
                                  endColumn?: number | null;
                                }> | null;
                              };
                            }> | null;
                            values: {
                              coverage: number;
                              missing?: Array<{
                                kind?: string | null;
                                name?: string | null;
                                startLine: number;
                                startColumn?: number | null;
                                endLine?: number | null;
                                endColumn?: number | null;
                              }> | null;
                            };
                          }> | null;
                          values: {
                            coverage: number;
                            missing?: Array<{
                              kind?: string | null;
                              name?: string | null;
                              startLine: number;
                              startColumn?: number | null;
                              endLine?: number | null;
                              endColumn?: number | null;
                            }> | null;
                          };
                        }> | null;
                        values: {
                          coverage: number;
                          missing?: Array<{
                            kind?: string | null;
                            name?: string | null;
                            startLine: number;
                            startColumn?: number | null;
                            endLine?: number | null;
                            endColumn?: number | null;
                          }> | null;
                        };
                      }> | null;
                      values: {
                        coverage: number;
                        missing?: Array<{
                          kind?: string | null;
                          name?: string | null;
                          startLine: number;
                          startColumn?: number | null;
                          endLine?: number | null;
                          endColumn?: number | null;
                        }> | null;
                      };
                    }> | null;
                    values: {
                      coverage: number;
                      missing?: Array<{
                        kind?: string | null;
                        name?: string | null;
                        startLine: number;
                        startColumn?: number | null;
                        endLine?: number | null;
                        endColumn?: number | null;
                      }> | null;
                    };
                  }> | null;
                  values: {
                    coverage: number;
                    missing?: Array<{
                      kind?: string | null;
                      name?: string | null;
                      startLine: number;
                      startColumn?: number | null;
                      endLine?: number | null;
                      endColumn?: number | null;
                    }> | null;
                  };
                }> | null;
                values: {
                  coverage: number;
                  missing?: Array<{
                    kind?: string | null;
                    name?: string | null;
                    startLine: number;
                    startColumn?: number | null;
                    endLine?: number | null;
                    endColumn?: number | null;
                  }> | null;
                };
              }> | null;
              values: {
                coverage: number;
                missing?: Array<{
                  kind?: string | null;
                  name?: string | null;
                  startLine: number;
                  startColumn?: number | null;
                  endLine?: number | null;
                  endColumn?: number | null;
                }> | null;
              };
            }> | null;
            values: {
              coverage: number;
              missing?: Array<{
                kind?: string | null;
                name?: string | null;
                startLine: number;
                startColumn?: number | null;
                endLine?: number | null;
                endColumn?: number | null;
              }> | null;
            };
          };
        }
    >;
  } | null;
};

export type GroupFragment = {
  slug: string;
  title: string;
  description?: string | null;
  score: number;
  refs: Array<{ weight: number; target: { slug: string } }>;
};

export type PluginFragment = {
  slug: string;
  title: string;
  description?: string | null;
  docsUrl?: string | null;
  icon: MaterialIcon;
  packageName?: string | null;
  packageVersion?: string | null;
  runnerStartDate?: string | null;
  runnerDuration?: number | null;
  audits: {
    edges: Array<{
      node: {
        slug: string;
        title: string;
        description?: string | null;
        docsUrl?: string | null;
        score: number;
        value: number;
        formattedValue?: string | null;
        details?: {
          enabled: boolean;
          tables: Array<{
            title?: string | null;
            header?: Array<{
              content: string;
              alignment: TableAlignment;
            }> | null;
            body: Array<Array<{ content: string; alignment: TableAlignment }>>;
          }>;
          trees: Array<
            | {
                __typename: 'BasicTree';
                title?: string | null;
                root: {
                  name: string;
                  children?: Array<{
                    name: string;
                    children?: Array<{
                      name: string;
                      children?: Array<{
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          children?: Array<{
                                            name: string;
                                            children?: Array<{
                                              name: string;
                                              children?: Array<{
                                                name: string;
                                                children?: Array<{
                                                  name: string;
                                                  children?: Array<{
                                                    name: string;
                                                    children?: Array<{
                                                      name: string;
                                                      children?: Array<{
                                                        name: string;
                                                        customValues?: Array<{
                                                          key: string;
                                                          value: string;
                                                        }> | null;
                                                      }> | null;
                                                      customValues?: Array<{
                                                        key: string;
                                                        value: string;
                                                      }> | null;
                                                    }> | null;
                                                    customValues?: Array<{
                                                      key: string;
                                                      value: string;
                                                    }> | null;
                                                  }> | null;
                                                  customValues?: Array<{
                                                    key: string;
                                                    value: string;
                                                  }> | null;
                                                }> | null;
                                                customValues?: Array<{
                                                  key: string;
                                                  value: string;
                                                }> | null;
                                              }> | null;
                                              customValues?: Array<{
                                                key: string;
                                                value: string;
                                              }> | null;
                                            }> | null;
                                            customValues?: Array<{
                                              key: string;
                                              value: string;
                                            }> | null;
                                          }> | null;
                                          customValues?: Array<{
                                            key: string;
                                            value: string;
                                          }> | null;
                                        }> | null;
                                        customValues?: Array<{
                                          key: string;
                                          value: string;
                                        }> | null;
                                      }> | null;
                                      customValues?: Array<{
                                        key: string;
                                        value: string;
                                      }> | null;
                                    }> | null;
                                    customValues?: Array<{
                                      key: string;
                                      value: string;
                                    }> | null;
                                  }> | null;
                                  customValues?: Array<{
                                    key: string;
                                    value: string;
                                  }> | null;
                                }> | null;
                                customValues?: Array<{
                                  key: string;
                                  value: string;
                                }> | null;
                              }> | null;
                              customValues?: Array<{
                                key: string;
                                value: string;
                              }> | null;
                            }> | null;
                            customValues?: Array<{
                              key: string;
                              value: string;
                            }> | null;
                          }> | null;
                          customValues?: Array<{
                            key: string;
                            value: string;
                          }> | null;
                        }> | null;
                        customValues?: Array<{
                          key: string;
                          value: string;
                        }> | null;
                      }> | null;
                      customValues?: Array<{
                        key: string;
                        value: string;
                      }> | null;
                    }> | null;
                    customValues?: Array<{ key: string; value: string }> | null;
                  }> | null;
                  customValues?: Array<{ key: string; value: string }> | null;
                };
              }
            | {
                __typename: 'CoverageTree';
                title?: string | null;
                root: {
                  name: string;
                  children?: Array<{
                    name: string;
                    children?: Array<{
                      name: string;
                      children?: Array<{
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          children?: Array<{
                                            name: string;
                                            children?: Array<{
                                              name: string;
                                              children?: Array<{
                                                name: string;
                                                children?: Array<{
                                                  name: string;
                                                  children?: Array<{
                                                    name: string;
                                                    children?: Array<{
                                                      name: string;
                                                      children?: Array<{
                                                        name: string;
                                                        values: {
                                                          coverage: number;
                                                          missing?: Array<{
                                                            kind?:
                                                              | string
                                                              | null;
                                                            name?:
                                                              | string
                                                              | null;
                                                            startLine: number;
                                                            startColumn?:
                                                              | number
                                                              | null;
                                                            endLine?:
                                                              | number
                                                              | null;
                                                            endColumn?:
                                                              | number
                                                              | null;
                                                          }> | null;
                                                        };
                                                      }> | null;
                                                      values: {
                                                        coverage: number;
                                                        missing?: Array<{
                                                          kind?: string | null;
                                                          name?: string | null;
                                                          startLine: number;
                                                          startColumn?:
                                                            | number
                                                            | null;
                                                          endLine?:
                                                            | number
                                                            | null;
                                                          endColumn?:
                                                            | number
                                                            | null;
                                                        }> | null;
                                                      };
                                                    }> | null;
                                                    values: {
                                                      coverage: number;
                                                      missing?: Array<{
                                                        kind?: string | null;
                                                        name?: string | null;
                                                        startLine: number;
                                                        startColumn?:
                                                          | number
                                                          | null;
                                                        endLine?: number | null;
                                                        endColumn?:
                                                          | number
                                                          | null;
                                                      }> | null;
                                                    };
                                                  }> | null;
                                                  values: {
                                                    coverage: number;
                                                    missing?: Array<{
                                                      kind?: string | null;
                                                      name?: string | null;
                                                      startLine: number;
                                                      startColumn?:
                                                        | number
                                                        | null;
                                                      endLine?: number | null;
                                                      endColumn?: number | null;
                                                    }> | null;
                                                  };
                                                }> | null;
                                                values: {
                                                  coverage: number;
                                                  missing?: Array<{
                                                    kind?: string | null;
                                                    name?: string | null;
                                                    startLine: number;
                                                    startColumn?: number | null;
                                                    endLine?: number | null;
                                                    endColumn?: number | null;
                                                  }> | null;
                                                };
                                              }> | null;
                                              values: {
                                                coverage: number;
                                                missing?: Array<{
                                                  kind?: string | null;
                                                  name?: string | null;
                                                  startLine: number;
                                                  startColumn?: number | null;
                                                  endLine?: number | null;
                                                  endColumn?: number | null;
                                                }> | null;
                                              };
                                            }> | null;
                                            values: {
                                              coverage: number;
                                              missing?: Array<{
                                                kind?: string | null;
                                                name?: string | null;
                                                startLine: number;
                                                startColumn?: number | null;
                                                endLine?: number | null;
                                                endColumn?: number | null;
                                              }> | null;
                                            };
                                          }> | null;
                                          values: {
                                            coverage: number;
                                            missing?: Array<{
                                              kind?: string | null;
                                              name?: string | null;
                                              startLine: number;
                                              startColumn?: number | null;
                                              endLine?: number | null;
                                              endColumn?: number | null;
                                            }> | null;
                                          };
                                        }> | null;
                                        values: {
                                          coverage: number;
                                          missing?: Array<{
                                            kind?: string | null;
                                            name?: string | null;
                                            startLine: number;
                                            startColumn?: number | null;
                                            endLine?: number | null;
                                            endColumn?: number | null;
                                          }> | null;
                                        };
                                      }> | null;
                                      values: {
                                        coverage: number;
                                        missing?: Array<{
                                          kind?: string | null;
                                          name?: string | null;
                                          startLine: number;
                                          startColumn?: number | null;
                                          endLine?: number | null;
                                          endColumn?: number | null;
                                        }> | null;
                                      };
                                    }> | null;
                                    values: {
                                      coverage: number;
                                      missing?: Array<{
                                        kind?: string | null;
                                        name?: string | null;
                                        startLine: number;
                                        startColumn?: number | null;
                                        endLine?: number | null;
                                        endColumn?: number | null;
                                      }> | null;
                                    };
                                  }> | null;
                                  values: {
                                    coverage: number;
                                    missing?: Array<{
                                      kind?: string | null;
                                      name?: string | null;
                                      startLine: number;
                                      startColumn?: number | null;
                                      endLine?: number | null;
                                      endColumn?: number | null;
                                    }> | null;
                                  };
                                }> | null;
                                values: {
                                  coverage: number;
                                  missing?: Array<{
                                    kind?: string | null;
                                    name?: string | null;
                                    startLine: number;
                                    startColumn?: number | null;
                                    endLine?: number | null;
                                    endColumn?: number | null;
                                  }> | null;
                                };
                              }> | null;
                              values: {
                                coverage: number;
                                missing?: Array<{
                                  kind?: string | null;
                                  name?: string | null;
                                  startLine: number;
                                  startColumn?: number | null;
                                  endLine?: number | null;
                                  endColumn?: number | null;
                                }> | null;
                              };
                            }> | null;
                            values: {
                              coverage: number;
                              missing?: Array<{
                                kind?: string | null;
                                name?: string | null;
                                startLine: number;
                                startColumn?: number | null;
                                endLine?: number | null;
                                endColumn?: number | null;
                              }> | null;
                            };
                          }> | null;
                          values: {
                            coverage: number;
                            missing?: Array<{
                              kind?: string | null;
                              name?: string | null;
                              startLine: number;
                              startColumn?: number | null;
                              endLine?: number | null;
                              endColumn?: number | null;
                            }> | null;
                          };
                        }> | null;
                        values: {
                          coverage: number;
                          missing?: Array<{
                            kind?: string | null;
                            name?: string | null;
                            startLine: number;
                            startColumn?: number | null;
                            endLine?: number | null;
                            endColumn?: number | null;
                          }> | null;
                        };
                      }> | null;
                      values: {
                        coverage: number;
                        missing?: Array<{
                          kind?: string | null;
                          name?: string | null;
                          startLine: number;
                          startColumn?: number | null;
                          endLine?: number | null;
                          endColumn?: number | null;
                        }> | null;
                      };
                    }> | null;
                    values: {
                      coverage: number;
                      missing?: Array<{
                        kind?: string | null;
                        name?: string | null;
                        startLine: number;
                        startColumn?: number | null;
                        endLine?: number | null;
                        endColumn?: number | null;
                      }> | null;
                    };
                  }> | null;
                  values: {
                    coverage: number;
                    missing?: Array<{
                      kind?: string | null;
                      name?: string | null;
                      startLine: number;
                      startColumn?: number | null;
                      endLine?: number | null;
                      endColumn?: number | null;
                    }> | null;
                  };
                };
              }
          >;
        } | null;
      };
    }>;
  };
  groups: Array<{
    slug: string;
    title: string;
    description?: string | null;
    score: number;
    refs: Array<{ weight: number; target: { slug: string } }>;
  }>;
};

export type AuditRefFragment = { slug: string; plugin: { slug: string } };

export type GroupRefFragment = { slug: string; plugin: { slug: string } };

export type IssueFragment = {
  message: string;
  severity: IssueSeverity;
  audit: { slug: string; plugin: { slug: string } };
  source?:
    | {
        __typename: 'SourceCodeLocation';
        filePath: string;
        startLine?: number | null;
        startColumn?: number | null;
        endLine?: number | null;
        endColumn?: number | null;
      }
    | {
        __typename: 'SourceUrlLocation';
        url: string;
        snippet?: string | null;
        selector?: string | null;
      }
    | null;
};

type IssueSource_SourceCodeLocation_Fragment = {
  __typename: 'SourceCodeLocation';
  filePath: string;
  startLine?: number | null;
  startColumn?: number | null;
  endLine?: number | null;
  endColumn?: number | null;
};

type IssueSource_SourceUrlLocation_Fragment = {
  __typename: 'SourceUrlLocation';
  url: string;
  snippet?: string | null;
  selector?: string | null;
};

export type IssueSourceFragment =
  | IssueSource_SourceCodeLocation_Fragment
  | IssueSource_SourceUrlLocation_Fragment;

export type TableFragment = {
  title?: string | null;
  header?: Array<{ content: string; alignment: TableAlignment }> | null;
  body: Array<Array<{ content: string; alignment: TableAlignment }>>;
};

type Tree_BasicTree_Fragment = {
  __typename: 'BasicTree';
  title?: string | null;
  root: {
    name: string;
    children?: Array<{
      name: string;
      children?: Array<{
        name: string;
        children?: Array<{
          name: string;
          children?: Array<{
            name: string;
            children?: Array<{
              name: string;
              children?: Array<{
                name: string;
                children?: Array<{
                  name: string;
                  children?: Array<{
                    name: string;
                    children?: Array<{
                      name: string;
                      children?: Array<{
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          customValues?: Array<{
                                            key: string;
                                            value: string;
                                          }> | null;
                                        }> | null;
                                        customValues?: Array<{
                                          key: string;
                                          value: string;
                                        }> | null;
                                      }> | null;
                                      customValues?: Array<{
                                        key: string;
                                        value: string;
                                      }> | null;
                                    }> | null;
                                    customValues?: Array<{
                                      key: string;
                                      value: string;
                                    }> | null;
                                  }> | null;
                                  customValues?: Array<{
                                    key: string;
                                    value: string;
                                  }> | null;
                                }> | null;
                                customValues?: Array<{
                                  key: string;
                                  value: string;
                                }> | null;
                              }> | null;
                              customValues?: Array<{
                                key: string;
                                value: string;
                              }> | null;
                            }> | null;
                            customValues?: Array<{
                              key: string;
                              value: string;
                            }> | null;
                          }> | null;
                          customValues?: Array<{
                            key: string;
                            value: string;
                          }> | null;
                        }> | null;
                        customValues?: Array<{
                          key: string;
                          value: string;
                        }> | null;
                      }> | null;
                      customValues?: Array<{
                        key: string;
                        value: string;
                      }> | null;
                    }> | null;
                    customValues?: Array<{ key: string; value: string }> | null;
                  }> | null;
                  customValues?: Array<{ key: string; value: string }> | null;
                }> | null;
                customValues?: Array<{ key: string; value: string }> | null;
              }> | null;
              customValues?: Array<{ key: string; value: string }> | null;
            }> | null;
            customValues?: Array<{ key: string; value: string }> | null;
          }> | null;
          customValues?: Array<{ key: string; value: string }> | null;
        }> | null;
        customValues?: Array<{ key: string; value: string }> | null;
      }> | null;
      customValues?: Array<{ key: string; value: string }> | null;
    }> | null;
    customValues?: Array<{ key: string; value: string }> | null;
  };
};

type Tree_CoverageTree_Fragment = {
  __typename: 'CoverageTree';
  title?: string | null;
  root: {
    name: string;
    children?: Array<{
      name: string;
      children?: Array<{
        name: string;
        children?: Array<{
          name: string;
          children?: Array<{
            name: string;
            children?: Array<{
              name: string;
              children?: Array<{
                name: string;
                children?: Array<{
                  name: string;
                  children?: Array<{
                    name: string;
                    children?: Array<{
                      name: string;
                      children?: Array<{
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        children?: Array<{
                                          name: string;
                                          values: {
                                            coverage: number;
                                            missing?: Array<{
                                              kind?: string | null;
                                              name?: string | null;
                                              startLine: number;
                                              startColumn?: number | null;
                                              endLine?: number | null;
                                              endColumn?: number | null;
                                            }> | null;
                                          };
                                        }> | null;
                                        values: {
                                          coverage: number;
                                          missing?: Array<{
                                            kind?: string | null;
                                            name?: string | null;
                                            startLine: number;
                                            startColumn?: number | null;
                                            endLine?: number | null;
                                            endColumn?: number | null;
                                          }> | null;
                                        };
                                      }> | null;
                                      values: {
                                        coverage: number;
                                        missing?: Array<{
                                          kind?: string | null;
                                          name?: string | null;
                                          startLine: number;
                                          startColumn?: number | null;
                                          endLine?: number | null;
                                          endColumn?: number | null;
                                        }> | null;
                                      };
                                    }> | null;
                                    values: {
                                      coverage: number;
                                      missing?: Array<{
                                        kind?: string | null;
                                        name?: string | null;
                                        startLine: number;
                                        startColumn?: number | null;
                                        endLine?: number | null;
                                        endColumn?: number | null;
                                      }> | null;
                                    };
                                  }> | null;
                                  values: {
                                    coverage: number;
                                    missing?: Array<{
                                      kind?: string | null;
                                      name?: string | null;
                                      startLine: number;
                                      startColumn?: number | null;
                                      endLine?: number | null;
                                      endColumn?: number | null;
                                    }> | null;
                                  };
                                }> | null;
                                values: {
                                  coverage: number;
                                  missing?: Array<{
                                    kind?: string | null;
                                    name?: string | null;
                                    startLine: number;
                                    startColumn?: number | null;
                                    endLine?: number | null;
                                    endColumn?: number | null;
                                  }> | null;
                                };
                              }> | null;
                              values: {
                                coverage: number;
                                missing?: Array<{
                                  kind?: string | null;
                                  name?: string | null;
                                  startLine: number;
                                  startColumn?: number | null;
                                  endLine?: number | null;
                                  endColumn?: number | null;
                                }> | null;
                              };
                            }> | null;
                            values: {
                              coverage: number;
                              missing?: Array<{
                                kind?: string | null;
                                name?: string | null;
                                startLine: number;
                                startColumn?: number | null;
                                endLine?: number | null;
                                endColumn?: number | null;
                              }> | null;
                            };
                          }> | null;
                          values: {
                            coverage: number;
                            missing?: Array<{
                              kind?: string | null;
                              name?: string | null;
                              startLine: number;
                              startColumn?: number | null;
                              endLine?: number | null;
                              endColumn?: number | null;
                            }> | null;
                          };
                        }> | null;
                        values: {
                          coverage: number;
                          missing?: Array<{
                            kind?: string | null;
                            name?: string | null;
                            startLine: number;
                            startColumn?: number | null;
                            endLine?: number | null;
                            endColumn?: number | null;
                          }> | null;
                        };
                      }> | null;
                      values: {
                        coverage: number;
                        missing?: Array<{
                          kind?: string | null;
                          name?: string | null;
                          startLine: number;
                          startColumn?: number | null;
                          endLine?: number | null;
                          endColumn?: number | null;
                        }> | null;
                      };
                    }> | null;
                    values: {
                      coverage: number;
                      missing?: Array<{
                        kind?: string | null;
                        name?: string | null;
                        startLine: number;
                        startColumn?: number | null;
                        endLine?: number | null;
                        endColumn?: number | null;
                      }> | null;
                    };
                  }> | null;
                  values: {
                    coverage: number;
                    missing?: Array<{
                      kind?: string | null;
                      name?: string | null;
                      startLine: number;
                      startColumn?: number | null;
                      endLine?: number | null;
                      endColumn?: number | null;
                    }> | null;
                  };
                }> | null;
                values: {
                  coverage: number;
                  missing?: Array<{
                    kind?: string | null;
                    name?: string | null;
                    startLine: number;
                    startColumn?: number | null;
                    endLine?: number | null;
                    endColumn?: number | null;
                  }> | null;
                };
              }> | null;
              values: {
                coverage: number;
                missing?: Array<{
                  kind?: string | null;
                  name?: string | null;
                  startLine: number;
                  startColumn?: number | null;
                  endLine?: number | null;
                  endColumn?: number | null;
                }> | null;
              };
            }> | null;
            values: {
              coverage: number;
              missing?: Array<{
                kind?: string | null;
                name?: string | null;
                startLine: number;
                startColumn?: number | null;
                endLine?: number | null;
                endColumn?: number | null;
              }> | null;
            };
          }> | null;
          values: {
            coverage: number;
            missing?: Array<{
              kind?: string | null;
              name?: string | null;
              startLine: number;
              startColumn?: number | null;
              endLine?: number | null;
              endColumn?: number | null;
            }> | null;
          };
        }> | null;
        values: {
          coverage: number;
          missing?: Array<{
            kind?: string | null;
            name?: string | null;
            startLine: number;
            startColumn?: number | null;
            endLine?: number | null;
            endColumn?: number | null;
          }> | null;
        };
      }> | null;
      values: {
        coverage: number;
        missing?: Array<{
          kind?: string | null;
          name?: string | null;
          startLine: number;
          startColumn?: number | null;
          endLine?: number | null;
          endColumn?: number | null;
        }> | null;
      };
    }> | null;
    values: {
      coverage: number;
      missing?: Array<{
        kind?: string | null;
        name?: string | null;
        startLine: number;
        startColumn?: number | null;
        endLine?: number | null;
        endColumn?: number | null;
      }> | null;
    };
  };
};

export type TreeFragment = Tree_BasicTree_Fragment | Tree_CoverageTree_Fragment;

export type BasicTreeNodeDataFragment = {
  name: string;
  customValues?: Array<{ key: string; value: string }> | null;
};

export type CoverageTreeNodeDataFragment = {
  name: string;
  values: {
    coverage: number;
    missing?: Array<{
      kind?: string | null;
      name?: string | null;
      startLine: number;
      startColumn?: number | null;
      endLine?: number | null;
      endColumn?: number | null;
    }> | null;
  };
};

export type UncoveredLocFragment = {
  kind?: string | null;
  name?: string | null;
  startLine: number;
  startColumn?: number | null;
  endLine?: number | null;
  endColumn?: number | null;
};

export type BasicTreeRootFragment = {
  name: string;
  children?: Array<{
    name: string;
    children?: Array<{
      name: string;
      children?: Array<{
        name: string;
        children?: Array<{
          name: string;
          children?: Array<{
            name: string;
            children?: Array<{
              name: string;
              children?: Array<{
                name: string;
                children?: Array<{
                  name: string;
                  children?: Array<{
                    name: string;
                    children?: Array<{
                      name: string;
                      children?: Array<{
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        customValues?: Array<{
                                          key: string;
                                          value: string;
                                        }> | null;
                                      }> | null;
                                      customValues?: Array<{
                                        key: string;
                                        value: string;
                                      }> | null;
                                    }> | null;
                                    customValues?: Array<{
                                      key: string;
                                      value: string;
                                    }> | null;
                                  }> | null;
                                  customValues?: Array<{
                                    key: string;
                                    value: string;
                                  }> | null;
                                }> | null;
                                customValues?: Array<{
                                  key: string;
                                  value: string;
                                }> | null;
                              }> | null;
                              customValues?: Array<{
                                key: string;
                                value: string;
                              }> | null;
                            }> | null;
                            customValues?: Array<{
                              key: string;
                              value: string;
                            }> | null;
                          }> | null;
                          customValues?: Array<{
                            key: string;
                            value: string;
                          }> | null;
                        }> | null;
                        customValues?: Array<{
                          key: string;
                          value: string;
                        }> | null;
                      }> | null;
                      customValues?: Array<{
                        key: string;
                        value: string;
                      }> | null;
                    }> | null;
                    customValues?: Array<{ key: string; value: string }> | null;
                  }> | null;
                  customValues?: Array<{ key: string; value: string }> | null;
                }> | null;
                customValues?: Array<{ key: string; value: string }> | null;
              }> | null;
              customValues?: Array<{ key: string; value: string }> | null;
            }> | null;
            customValues?: Array<{ key: string; value: string }> | null;
          }> | null;
          customValues?: Array<{ key: string; value: string }> | null;
        }> | null;
        customValues?: Array<{ key: string; value: string }> | null;
      }> | null;
      customValues?: Array<{ key: string; value: string }> | null;
    }> | null;
    customValues?: Array<{ key: string; value: string }> | null;
  }> | null;
  customValues?: Array<{ key: string; value: string }> | null;
};

export type CoverageTreeRootFragment = {
  name: string;
  children?: Array<{
    name: string;
    children?: Array<{
      name: string;
      children?: Array<{
        name: string;
        children?: Array<{
          name: string;
          children?: Array<{
            name: string;
            children?: Array<{
              name: string;
              children?: Array<{
                name: string;
                children?: Array<{
                  name: string;
                  children?: Array<{
                    name: string;
                    children?: Array<{
                      name: string;
                      children?: Array<{
                        name: string;
                        children?: Array<{
                          name: string;
                          children?: Array<{
                            name: string;
                            children?: Array<{
                              name: string;
                              children?: Array<{
                                name: string;
                                children?: Array<{
                                  name: string;
                                  children?: Array<{
                                    name: string;
                                    children?: Array<{
                                      name: string;
                                      children?: Array<{
                                        name: string;
                                        values: {
                                          coverage: number;
                                          missing?: Array<{
                                            kind?: string | null;
                                            name?: string | null;
                                            startLine: number;
                                            startColumn?: number | null;
                                            endLine?: number | null;
                                            endColumn?: number | null;
                                          }> | null;
                                        };
                                      }> | null;
                                      values: {
                                        coverage: number;
                                        missing?: Array<{
                                          kind?: string | null;
                                          name?: string | null;
                                          startLine: number;
                                          startColumn?: number | null;
                                          endLine?: number | null;
                                          endColumn?: number | null;
                                        }> | null;
                                      };
                                    }> | null;
                                    values: {
                                      coverage: number;
                                      missing?: Array<{
                                        kind?: string | null;
                                        name?: string | null;
                                        startLine: number;
                                        startColumn?: number | null;
                                        endLine?: number | null;
                                        endColumn?: number | null;
                                      }> | null;
                                    };
                                  }> | null;
                                  values: {
                                    coverage: number;
                                    missing?: Array<{
                                      kind?: string | null;
                                      name?: string | null;
                                      startLine: number;
                                      startColumn?: number | null;
                                      endLine?: number | null;
                                      endColumn?: number | null;
                                    }> | null;
                                  };
                                }> | null;
                                values: {
                                  coverage: number;
                                  missing?: Array<{
                                    kind?: string | null;
                                    name?: string | null;
                                    startLine: number;
                                    startColumn?: number | null;
                                    endLine?: number | null;
                                    endColumn?: number | null;
                                  }> | null;
                                };
                              }> | null;
                              values: {
                                coverage: number;
                                missing?: Array<{
                                  kind?: string | null;
                                  name?: string | null;
                                  startLine: number;
                                  startColumn?: number | null;
                                  endLine?: number | null;
                                  endColumn?: number | null;
                                }> | null;
                              };
                            }> | null;
                            values: {
                              coverage: number;
                              missing?: Array<{
                                kind?: string | null;
                                name?: string | null;
                                startLine: number;
                                startColumn?: number | null;
                                endLine?: number | null;
                                endColumn?: number | null;
                              }> | null;
                            };
                          }> | null;
                          values: {
                            coverage: number;
                            missing?: Array<{
                              kind?: string | null;
                              name?: string | null;
                              startLine: number;
                              startColumn?: number | null;
                              endLine?: number | null;
                              endColumn?: number | null;
                            }> | null;
                          };
                        }> | null;
                        values: {
                          coverage: number;
                          missing?: Array<{
                            kind?: string | null;
                            name?: string | null;
                            startLine: number;
                            startColumn?: number | null;
                            endLine?: number | null;
                            endColumn?: number | null;
                          }> | null;
                        };
                      }> | null;
                      values: {
                        coverage: number;
                        missing?: Array<{
                          kind?: string | null;
                          name?: string | null;
                          startLine: number;
                          startColumn?: number | null;
                          endLine?: number | null;
                          endColumn?: number | null;
                        }> | null;
                      };
                    }> | null;
                    values: {
                      coverage: number;
                      missing?: Array<{
                        kind?: string | null;
                        name?: string | null;
                        startLine: number;
                        startColumn?: number | null;
                        endLine?: number | null;
                        endColumn?: number | null;
                      }> | null;
                    };
                  }> | null;
                  values: {
                    coverage: number;
                    missing?: Array<{
                      kind?: string | null;
                      name?: string | null;
                      startLine: number;
                      startColumn?: number | null;
                      endLine?: number | null;
                      endColumn?: number | null;
                    }> | null;
                  };
                }> | null;
                values: {
                  coverage: number;
                  missing?: Array<{
                    kind?: string | null;
                    name?: string | null;
                    startLine: number;
                    startColumn?: number | null;
                    endLine?: number | null;
                    endColumn?: number | null;
                  }> | null;
                };
              }> | null;
              values: {
                coverage: number;
                missing?: Array<{
                  kind?: string | null;
                  name?: string | null;
                  startLine: number;
                  startColumn?: number | null;
                  endLine?: number | null;
                  endColumn?: number | null;
                }> | null;
              };
            }> | null;
            values: {
              coverage: number;
              missing?: Array<{
                kind?: string | null;
                name?: string | null;
                startLine: number;
                startColumn?: number | null;
                endLine?: number | null;
                endColumn?: number | null;
              }> | null;
            };
          }> | null;
          values: {
            coverage: number;
            missing?: Array<{
              kind?: string | null;
              name?: string | null;
              startLine: number;
              startColumn?: number | null;
              endLine?: number | null;
              endColumn?: number | null;
            }> | null;
          };
        }> | null;
        values: {
          coverage: number;
          missing?: Array<{
            kind?: string | null;
            name?: string | null;
            startLine: number;
            startColumn?: number | null;
            endLine?: number | null;
            endColumn?: number | null;
          }> | null;
        };
      }> | null;
      values: {
        coverage: number;
        missing?: Array<{
          kind?: string | null;
          name?: string | null;
          startLine: number;
          startColumn?: number | null;
          endLine?: number | null;
          endColumn?: number | null;
        }> | null;
      };
    }> | null;
    values: {
      coverage: number;
      missing?: Array<{
        kind?: string | null;
        name?: string | null;
        startLine: number;
        startColumn?: number | null;
        endLine?: number | null;
        endColumn?: number | null;
      }> | null;
    };
  }> | null;
  values: {
    coverage: number;
    missing?: Array<{
      kind?: string | null;
      name?: string | null;
      startLine: number;
      startColumn?: number | null;
      endLine?: number | null;
      endColumn?: number | null;
    }> | null;
  };
};

export const RepositoryFragmentDoc = gql`
  fragment Repository on Repository {
    __typename
    ... on GitHubRepository {
      owner
      repo
    }
    ... on GitLabRepository {
      owner
      repo
    }
    contents {
      url
      defaultBranch {
        name
      }
    }
  }
`;
export const CommitFragmentDoc = gql`
  fragment Commit on Commit {
    sha
    message
    author {
      name
      email
    }
    date
  }
`;
export const AuditRefFragmentDoc = gql`
  fragment AuditRef on Audit {
    slug
    plugin {
      slug
    }
  }
`;
export const GroupRefFragmentDoc = gql`
  fragment GroupRef on Group {
    slug
    plugin {
      slug
    }
  }
`;
export const CategoryFragmentDoc = gql`
  fragment Category on Category {
    slug
    title
    description
    score
    scoreTarget
    refs {
      target {
        __typename
        ...AuditRef
        ...GroupRef
      }
      weight
    }
  }
  ${AuditRefFragmentDoc}
  ${GroupRefFragmentDoc}
`;
export const TableFragmentDoc = gql`
  fragment Table on Table {
    title
    header {
      content
      alignment
    }
    body {
      content
      alignment
    }
  }
`;
export const BasicTreeNodeDataFragmentDoc = gql`
  fragment BasicTreeNodeData on BasicTreeNode {
    name
    customValues: values {
      key
      value
    }
  }
`;
export const BasicTreeRootFragmentDoc = gql`
  fragment BasicTreeRoot on BasicTreeNode {
    ...BasicTreeNodeData
    children {
      ...BasicTreeNodeData
      children {
        ...BasicTreeNodeData
        children {
          ...BasicTreeNodeData
          children {
            ...BasicTreeNodeData
            children {
              ...BasicTreeNodeData
              children {
                ...BasicTreeNodeData
                children {
                  ...BasicTreeNodeData
                  children {
                    ...BasicTreeNodeData
                    children {
                      ...BasicTreeNodeData
                      children {
                        ...BasicTreeNodeData
                        children {
                          ...BasicTreeNodeData
                          children {
                            ...BasicTreeNodeData
                            children {
                              ...BasicTreeNodeData
                              children {
                                ...BasicTreeNodeData
                                children {
                                  ...BasicTreeNodeData
                                  children {
                                    ...BasicTreeNodeData
                                    children {
                                      ...BasicTreeNodeData
                                      children {
                                        ...BasicTreeNodeData
                                        children {
                                          ...BasicTreeNodeData
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${BasicTreeNodeDataFragmentDoc}
`;
export const UncoveredLocFragmentDoc = gql`
  fragment UncoveredLOC on UncoveredLOC {
    kind
    name
    startLine
    startColumn
    endLine
    endColumn
  }
`;
export const CoverageTreeNodeDataFragmentDoc = gql`
  fragment CoverageTreeNodeData on CoverageTreeNode {
    name
    values {
      coverage
      missing {
        ...UncoveredLOC
      }
    }
  }
  ${UncoveredLocFragmentDoc}
`;
export const CoverageTreeRootFragmentDoc = gql`
  fragment CoverageTreeRoot on CoverageTreeNode {
    ...CoverageTreeNodeData
    children {
      ...CoverageTreeNodeData
      children {
        ...CoverageTreeNodeData
        children {
          ...CoverageTreeNodeData
          children {
            ...CoverageTreeNodeData
            children {
              ...CoverageTreeNodeData
              children {
                ...CoverageTreeNodeData
                children {
                  ...CoverageTreeNodeData
                  children {
                    ...CoverageTreeNodeData
                    children {
                      ...CoverageTreeNodeData
                      children {
                        ...CoverageTreeNodeData
                        children {
                          ...CoverageTreeNodeData
                          children {
                            ...CoverageTreeNodeData
                            children {
                              ...CoverageTreeNodeData
                              children {
                                ...CoverageTreeNodeData
                                children {
                                  ...CoverageTreeNodeData
                                  children {
                                    ...CoverageTreeNodeData
                                    children {
                                      ...CoverageTreeNodeData
                                      children {
                                        ...CoverageTreeNodeData
                                        children {
                                          ...CoverageTreeNodeData
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${CoverageTreeNodeDataFragmentDoc}
`;
export const TreeFragmentDoc = gql`
  fragment Tree on Tree {
    __typename
    ... on BasicTree {
      title
      root {
        ...BasicTreeRoot
      }
    }
    ... on CoverageTree {
      title
      root {
        ...CoverageTreeRoot
      }
    }
  }
  ${BasicTreeRootFragmentDoc}
  ${CoverageTreeRootFragmentDoc}
`;
export const AuditFragmentDoc = gql`
  fragment Audit on Audit {
    slug
    title
    description
    docsUrl
    score
    value
    formattedValue
    details @include(if: $withAuditDetails) {
      enabled
      tables {
        ...Table
      }
      trees {
        ...Tree
      }
    }
  }
  ${TableFragmentDoc}
  ${TreeFragmentDoc}
`;
export const GroupFragmentDoc = gql`
  fragment Group on Group {
    slug
    title
    description
    score
    refs {
      target {
        slug
      }
      weight
    }
  }
`;
export const PluginFragmentDoc = gql`
  fragment Plugin on Plugin {
    slug
    title
    description
    docsUrl
    icon
    packageName
    packageVersion
    runnerStartDate
    runnerDuration
    audits {
      edges {
        node {
          ...Audit
        }
      }
    }
    groups {
      ...Group
    }
  }
  ${AuditFragmentDoc}
  ${GroupFragmentDoc}
`;
export const IssueSourceFragmentDoc = gql`
  fragment IssueSource on IssueSource {
    __typename
    ... on SourceCodeLocation {
      filePath
      startLine
      startColumn
      endLine
      endColumn
    }
    ... on SourceUrlLocation {
      url
      snippet
      selector
    }
  }
`;
export const IssueFragmentDoc = gql`
  fragment Issue on Issue {
    audit {
      ...AuditRef
    }
    message
    severity
    source {
      ...IssueSource
    }
  }
  ${AuditRefFragmentDoc}
  ${IssueSourceFragmentDoc}
`;
export const ReportFragmentDoc = gql`
  fragment Report on Report {
    commit {
      ...Commit
    }
    categories {
      ...Category
    }
    plugins {
      ...Plugin
    }
    packageName
    packageVersion
    commandStartDate
    commandDuration
    issues @include(if: $withAuditDetails) {
      edges {
        node {
          ...Issue
        }
      }
    }
  }
  ${CommitFragmentDoc}
  ${CategoryFragmentDoc}
  ${PluginFragmentDoc}
  ${IssueFragmentDoc}
`;
export const ProjectFragmentDoc = gql`
  fragment Project on Project {
    slug
    friendlyName
    organization {
      slug
      friendlyName
    }
    repository {
      ...Repository
    }
    latestReport(maxCommits: $maxCommits) @include(if: $withLatestReport) {
      ...Report
    }
  }
  ${RepositoryFragmentDoc}
  ${ReportFragmentDoc}
`;
export const ReportUrlFragmentDoc = gql`
  fragment ReportUrl on Report {
    url
  }
`;
export const ReportComparisonUrlFragmentDoc = gql`
  fragment ReportComparisonUrl on ReportComparison {
    url
  }
`;
export const SaveReportDocument = gql`
  mutation saveReport(
    $organization: Slug!
    $project: Slug!
    $commit: CommitSHA!
    $plugins: [PluginReport!]!
    $categories: [CategoryConfig!]!
    $packageName: NpmPackageName
    $packageVersion: NpmPackageVersion
    $commandStartDate: Date
    $commandDuration: Int
  ) {
    saveReport(
      organization: $organization
      project: $project
      commit: $commit
      plugins: $plugins
      categories: $categories
      packageName: $packageName
      packageVersion: $packageVersion
      commandStartDate: $commandStartDate
      commandDuration: $commandDuration
    ) {
      ...ReportUrl
    }
  }
  ${ReportUrlFragmentDoc}
`;
export const ReportComparisonUrlDocument = gql`
  query reportComparisonUrl(
    $organization: Slug!
    $project: Slug!
    $before: String!
    $after: String!
  ) {
    project(organization: $organization, project: $project) {
      reportComparison(before: $before, after: $after) {
        ...ReportComparisonUrl
      }
    }
  }
  ${ReportComparisonUrlFragmentDoc}
`;
export const ReportByCommitDocument = gql`
  query reportByCommit(
    $organization: Slug!
    $project: Slug!
    $commit: CommitSHA!
    $withAuditDetails: Boolean = false
  ) {
    report(organization: $organization, project: $project, commit: $commit) {
      ...Report
    }
  }
  ${ReportFragmentDoc}
`;
export const LatestReportDocument = gql`
  query latestReport(
    $organization: Slug!
    $project: Slug!
    $withAuditDetails: Boolean = false
    $maxCommits: Int
  ) {
    project(organization: $organization, project: $project) {
      latestReport(maxCommits: $maxCommits) {
        ...Report
      }
    }
  }
  ${ReportFragmentDoc}
`;
export const ProjectsDocument = gql`
  query projects(
    $organization: Slug
    $withLatestReport: Boolean = false
    $withAuditDetails: Boolean = false
    $maxCommits: Int
  ) {
    projects(organization: $organization) {
      ...Project
    }
  }
  ${ProjectFragmentDoc}
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
  variables?: any,
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType,
  _variables,
) => action();

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper,
) {
  return {
    saveReport(
      variables: SaveReportMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal'],
    ): Promise<SaveReportMutation> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<SaveReportMutation>({
            document: SaveReportDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        'saveReport',
        'mutation',
        variables,
      );
    },
    reportComparisonUrl(
      variables: ReportComparisonUrlQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal'],
    ): Promise<ReportComparisonUrlQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<ReportComparisonUrlQuery>({
            document: ReportComparisonUrlDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        'reportComparisonUrl',
        'query',
        variables,
      );
    },
    reportByCommit(
      variables: ReportByCommitQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal'],
    ): Promise<ReportByCommitQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<ReportByCommitQuery>({
            document: ReportByCommitDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        'reportByCommit',
        'query',
        variables,
      );
    },
    latestReport(
      variables: LatestReportQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal'],
    ): Promise<LatestReportQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<LatestReportQuery>({
            document: LatestReportDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        'latestReport',
        'query',
        variables,
      );
    },
    projects(
      variables?: ProjectsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit['signal'],
    ): Promise<ProjectsQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<ProjectsQuery>({
            document: ProjectsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        'projects',
        'query',
        variables,
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
